import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../Config";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { Divider } from "primereact/divider";
import { TabView, TabPanel } from "primereact/tabview";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Skeleton } from "primereact/skeleton";
import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import {
  countryOptions,
  countryOptionTemplate,
} from "../utilities/CountryOptions";
import {
  phoneCodeOptions,
  phoneCodeOptionTemplate,
} from "../utilities/PhoneCodeOptions";

const Contacto = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { baseUrl } = useGlobalContext();
  // ===================== Estado base =====================
  const [loading, setLoading] = useState(true);
  const [persona, setPersona] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [view, setView] = useState("kanban");
  const today = useMemo(() => new Date(), []);
  const [addMode, setAddMode] = useState("buscar");
  const tipoFromTab =
    activeTab === 0 ? "NATURAL" : activeTab === 1 ? "JURIDICA" : null;

  const [personQuery, setPersonQuery] = useState("");
  const [personSugs, setPersonSugs] = useState([]);
  const [personSelected, setPersonSelected] = useState(null);
  const [noResults, setNoResults] = useState(false);
  const [rutBusquedaError, setRutBusquedaError] = useState("");

  // Tipos de relación
  const [tiposRel, setTiposRel] = useState([]);
  const [tipoRelacionId, setTipoRelacionId] = useState(null);
  const [tiposRelLoading, setTiposRelLoading] = useState(false);
  const [tiposRelError, setTiposRelError] = useState("");

  const [showDirExtra, setShowDirExtra] = useState(false);
  const [showCorreoExtra, setShowCorreoExtra] = useState(false);
  const [showTelefonoExtra, setShowTelefonoExtra] = useState(false);

  const [dirQuery, setDirQuery] = useState("");
  const [dirSugs, setDirSugs] = useState([]);
  const [dirSelected, setDirSelected] = useState(null);
  const [dirLoading, setDirLoading] = useState(false);
  const [tiposDireccion, setTiposDireccion] = useState([]);
  const [tipoSeleccionado, setTipoSeleccionado] = useState(null);

  const [detailOpen, setDetailOpen] = useState(false);
  const [detailContacto, setDetailContacto] = useState(null);

  const [personSearchLoading, setPersonSearchLoading] = useState(false);

  const [phoneCountryCode, setPhoneCountryCode] = useState("+56");

  const [countryAutoLoading, setCountryAutoLoading] = useState(false);
  const [countryAutoError, setCountryAutoError] = useState(false);
  const [nacionalidadTouched, setNacionalidadTouched] = useState(false);

  // ===================== Foto de perfil =====================
  const [fotoDataUrl, setFotoDataUrl] = useState(null);
  const [fotoUploading, setFotoUploading] = useState(false);
  const [fotoError, setFotoError] = useState("");
  const [fotoFile, setFotoFile] = useState(null);
  const [fotoByPersonaId, setFotoByPersonaId] = useState({});
  // shape: { [personaId]: "data:image/png;base64,...." | null }

  const buildDataUrlFromApi = (tipo, archivoBase64) => {
    if (!archivoBase64) return null;
    // tu backend guarda tipo como "image/png;base64" -> para dataURL necesitamos "image/png"
    const mime = (tipo || "").replace(/;base64$/i, "").trim() || "image/jpeg";
    const clean = archivoBase64.includes(",")
      ? archivoBase64.split(",").slice(1).join(",").trim()
      : archivoBase64.trim();
    return `data:${mime};base64,${clean}`;
  };

  const fileToDataUrl = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error("No se pudo leer el archivo"));
      reader.onload = () => resolve(String(reader.result || ""));
      reader.readAsDataURL(file);
    });

  const toAllowedTipo = (dataUrl) => {
    const m = /^data:(image\/[a-zA-Z0-9.+-]+);base64,/.exec(dataUrl);
    if (!m) return null;

    const mime = m[1].toLowerCase(); // image/png, image/jpeg, image/webp...
    if (mime === "image/jpeg") return "image/jpeg;base64";
    if (mime === "image/jpg") return "image/jpg;base64";
    if (mime === "image/png") return "image/png;base64";
    if (mime === "image/webp") return "image/webp;base64";
    return null;
  };

  const fetchFotoPerfil = async (personaId) => {
    if (!personaId) return;

    try {
      const resp = await fetch(`${baseUrl}persona/fotoperfil/${personaId}`, {
        credentials: "include",
      });

      if (!resp.ok) {
        setFotoDataUrl(null);
        return;
      }

      const data = await resp.json();
      if (!data?.archivo || !data?.tipo) {
        setFotoDataUrl(null);
        return;
      }

      setFotoDataUrl(`data:${data.tipo},${data.archivo}`);
    } catch (e) {
      console.error("Error cargando foto:", e);
      setFotoDataUrl(null);
    }
  };

  const fetchFotosPerfil = async (personaId) => {
    // ya la tenemos en cache (incluye null)
    if (fotoByPersonaId.hasOwnProperty(personaId)) return;

    try {
      const resp = await fetch(`${baseUrl}persona/fotoperfil/${personaId}`, {
        credentials: "include",
      });

      if (resp.status === 404) {
        setFotoByPersonaId((prev) => ({ ...prev, [personaId]: null }));
        return;
      }

      if (!resp.ok) {
        console.error("Error obteniendo foto perfil:", await resp.text());
        return;
      }

      const data = await resp.json();
      const src = buildDataUrlFromApi(data.tipo, data.archivo);

      setFotoByPersonaId((prev) => ({ ...prev, [personaId]: src || null }));
    } catch (e) {
      console.error("Error obteniendo foto perfil:", e);
    }
  };

  const uploadFotoPerfil = async () => {
    if (!persona?.id) return;
    if (!fotoFile) {
      setFotoError("Selecciona una imagen primero.");
      return;
    }

    try {
      setFotoUploading(true);
      setFotoError("");

      const dataUrl = await fileToDataUrl(fotoFile);
      const tipo = toAllowedTipo(dataUrl);

      if (!tipo) {
        setFotoError("Tipo no permitido. Usa JPG/JPEG/PNG/WebP.");
        return;
      }

      const payload = {
        personaId: persona.id,
        tipo,
        archivo: dataUrl,
      };

      const resp = await fetch(`${baseUrl}persona/subir/fotoperfil`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!resp.ok) throw new Error(await resp.text());
      await fetchFotoPerfil(persona.id);
      try {
        const pResp = await fetch(`${baseUrl}persona/${persona.id}`, {
          credentials: "include",
        });
        if (pResp.ok) {
          const updated = await pResp.json();
          setPersona(updated);
        }
      } catch {}

      setFotoFile(null);
    } catch (e) {
      console.error(e);
      const msg = "No se pudo subir la foto. " + (e?.message || "");
      setFotoError(msg);
      notifyError(msg);
    } finally {
      setFotoUploading(false);
    }
  };

  // formulario crear
  const [nuevo, setNuevo] = useState({
    // común
    rut: "",
    nacionalidad: "",

    // NATURAL
    primerNombre: "",
    segundoNombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    genero: "",
    fechaNacimiento: "",

    // JURIDICA
    razonSocial: "",
  });

  // Form NATURAL + errores
  const [form, setForm] = useState({
    primerNombre: "",
    segundoNombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    fechaNacimiento: null,
    genero: "",
  });
  const [errors, setErrors] = useState({});
  const [rutStatusNuevo, setRutStatusNuevo] = useState(null);
  const [rutNuevoError, setRutNuevoError] = useState("");
  const [rutNuevoExists, setRutNuevoExists] = useState(false);

  // Opciones de género
  const generoOptions = [
    { label: "Masculino", value: "M" },
    { label: "Femenino", value: "F" },
    { label: "Otro", value: "OTRO" },
  ];

  const [dirExtra, setDirExtra] = useState({
    calle: "",
    comuna: "",
    ciudad: "",
    pais: "",
  });

  const [correoExtra, setCorreoExtra] = useState({
    email: "",
    etiqueta: "",
  });

  const [telExtra, setTelExtra] = useState({
    numero: "",
    etiqueta: "",
  });

  // setField helper
  const setField = (name, value) => {
    setForm((p) => ({ ...p, [name]: value }));
    setErrors((e) => ({ ...e, [name]: undefined }));
  };

  const formatRutInput = (value) => {
    // deja solo números y K/k
    const cleaned = (value || "").replace(/[^\dkK]/g, "").toUpperCase();

    if (cleaned.length === 0) return "";
    if (cleaned.length === 1) return cleaned; // solo el primer dígito / DV

    const body = cleaned.slice(0, -1);
    const dv = cleaned.slice(-1);

    // poner puntos cada 3 dígitos desde la derecha
    const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return `${withDots}-${dv}`;
  };

  const personaCountry = useMemo(() => {
    if (!persona?.nacionalidad) return null;

    return countryOptions.find(
      (c) => c.code === persona.nacionalidad || c.value === persona.nacionalidad
    );
  }, [persona]);

  // Estados, helpers y funciones para edicion de datos persona
  const [editOpen, setEditOpen] = useState(false);
  const [editSaving, setEditSaving] = useState(false);
  const [editError, setEditError] = useState("");
  const [editTipo, setEditTipo] = useState(null);
  const [editForm, setEditForm] = useState({
    rut: "",
    nacionalidad: "",
    descripcionLead: "",
    primerNombre: "",
    segundoNombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    genero: "",
    fechaNacimiento: null,
    razonSocial: "",
  });
  const [editErrors, setEditErrors] = useState({});

  const setEditField = (name, value) => {
    setEditForm((p) => ({ ...p, [name]: value }));
    setEditErrors((e) => ({ ...e, [name]: undefined }));
  };

  const openEditPersona = () => {
    if (!persona) return;

    const t = (persona.tipo || "").toUpperCase();

    setEditTipo(t);
    setEditError("");
    setEditErrors({});

    setEditForm({
      rut: persona.rut || "",
      nacionalidad: persona.nacionalidad || "",
      descripcionLead:
        persona.descripcionLead ||
        persona.leadDescripcion ||
        persona.descripcion ||
        "",
      primerNombre: persona.primerNombre || "",
      segundoNombre: persona.segundoNombre || "",
      apellidoPaterno: persona.apellidoPaterno || "",
      apellidoMaterno: persona.apellidoMaterno || "",
      genero: persona.genero || "",
      fechaNacimiento: persona.fechaNacimiento
        ? parseIsoDate(persona.fechaNacimiento)
        : null,
      razonSocial: persona.razonSocial || "",
    });

    setEditOpen(true);
  };

  const validateEdit = () => {
    const errs = {};
    const originalTipo = (persona?.tipo || "").toUpperCase();
    const t = (editTipo || "").toUpperCase();

    // validar RUT si viene
    if (editForm.rut && !isValidRut(editForm.rut)) {
      errs.rut = "RUT inválido";
    }

    // conversión LEAD -> NATURAL
    if (originalTipo === "LEAD" && t === "NATURAL") {
      if (!editForm.primerNombre?.trim())
        errs.primerNombre = "Requerido al convertir a NATURAL";
      if (!editForm.apellidoPaterno?.trim())
        errs.apellidoPaterno = "Requerido al convertir a NATURAL";
      if (!editForm.apellidoMaterno?.trim())
        errs.apellidoMaterno = "Requerido al convertir a NATURAL";
    }

    // conversión LEAD -> JURIDICA
    if (originalTipo === "LEAD" && t === "JURIDICA") {
      if (!editForm.razonSocial?.trim())
        errs.razonSocial = "Razón social requerida al convertir a JURIDICA";
    }

    setEditErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSaveEditPersona = async () => {
    if (!persona) return;
    if (editSaving) return;

    const originalTipo = (persona.tipo || "").toUpperCase();
    const t = (editTipo || "").toUpperCase();

    if (!validateEdit()) {
      setEditError("Corrige los errores del formulario.");
      return;
    }

    try {
      setEditSaving(true);
      setEditError("");

      const payload = {
        tipo: t,
        rut: editForm.rut || null,
        nacionalidad: editForm.nacionalidad || null,
      };

      if (t === "LEAD") {
        payload.descripcionLead = editForm.descripcionLead || null;
      } else if (t === "NATURAL") {
        payload.primerNombre = editForm.primerNombre || null;
        payload.segundoNombre = editForm.segundoNombre || null;
        payload.apellidoPaterno = editForm.apellidoPaterno || null;
        payload.apellidoMaterno = editForm.apellidoMaterno || null;
        payload.genero = editForm.genero || null;
        payload.fechaNacimiento = editForm.fechaNacimiento
          ? toIsoDate(editForm.fechaNacimiento)
          : null;
      } else if (t === "JURIDICA") {
        payload.razonSocial = editForm.razonSocial || null;
      }

      const resp = await fetch(`${baseUrl}persona/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!resp.ok) {
        const txt = await resp.text();
        throw new Error(txt || "Error actualizando persona");
      }

      const updated = await resp.json();
      setPersona(updated);
      setEditOpen(false);
    } catch (e) {
      console.error(e);
      const msg =
        "No se pudo actualizar la persona. " + (e?.message || "").toString();
      setEditError(msg);
      notifyError(msg);
    } finally {
      setEditSaving(false);
    }
  };

  // datasets de pestañas
  const [relNaturales, setRelNaturales] = useState([]);
  const [relJuridicas, setRelJuridicas] = useState([]);
  const [direcciones, setDirecciones] = useState([]);
  const [emails, setEmails] = useState([]);
  const [telefonos, setTelefonos] = useState([]);

  // Filtros del Sidebar
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [debounced, setDebounced] = useState("");

  const [addOpen, setAddOpen] = useState(false);
  const [addData, setAddData] = useState({});

  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  const notifyError = (msg) => {
    console.error(msg);
    window.alert(msg);
  };

  // Debounce de búsqueda (mejora UX)
  useEffect(() => {
    const t = setTimeout(() => setDebounced(query.trim()), 250);
    return () => clearTimeout(t);
  }, [query]);

  // Fetchs

  const fetchCorreos = async (personaId) => {
    const resp = await fetch(`${baseUrl}correo/lista/${personaId}`, {
      credentials: "include",
    });
    if (!resp.ok) {
      const txt = await resp.text();
      throw new Error(txt || "Error listando correos");
    }
    const data = await resp.json();
    return (data.items || []).map((c) => ({
      id: c.id,
      email: c.email,
      etiqueta: c.etiqueta,
      principal: c.principal ?? c.isPrincipal ?? false,
      vigente: c.vigente !== undefined ? c.vigente : true,
    }));
  };

  const fetchTelefonos = async (personaId) => {
    const resp = await fetch(`${baseUrl}telefono/lista/${personaId}`, {
      credentials: "include",
    });
    if (!resp.ok) {
      const txt = await resp.text();
      throw new Error(txt || "Error listando teléfonos");
    }
    const data = await resp.json();
    return (data.items || []).map((t) => ({
      id: t.id,
      numero: t.telefono,
      etiqueta: t.etiqueta,
      principal: t.principal ?? t.isPrincipal ?? false,
      vigente: t.vigente !== undefined ? t.vigente : true,
    }));
  };

  // ==== buscar personas ====
  const fetchPersonas = async (query) => {
    const q = (query || "").trim();
    if (!q) {
      setPersonSugs([]);
      setNoResults(false);
      setRutBusquedaError("");
      setPersonSearchLoading(false);
      return;
    }

    setPersonSearchLoading(true);
    const cleaned = q.replace(/[^\dkK]/g, "").toUpperCase();
    const isRutLike = /^[0-9]+[0-9kK]?$/.test(cleaned) || q.includes("-");
    const isRut = isRutLike && cleaned.length >= 7;

    let paramName = "q";
    let paramValue = encodeURIComponent(q);

    if (isRut) {
      const formattedRut = formatRut(cleaned);

      paramName = "rut";
      paramValue = encodeURIComponent(formattedRut);

      // módulo 11
      if (!isValidRut(formattedRut)) {
        setPersonSugs([]);
        setNoResults(false); // no mostramos el form de creación todavía
        setRutBusquedaError("RUT inválido");
        setPersonSearchLoading(false);
        return;
      }

      setRutBusquedaError("");
    } else {
      // búsqueda por nombre
      setRutBusquedaError("");
    }

    const url = `${baseUrl}personas/buscar?${paramName}=${paramValue}`;

    try {
      const resp = await fetch(url, { credentials: "include" });
      if (!resp.ok) {
        setPersonSugs([]);
        setNoResults(true);
        if (isRut) setRutBusquedaError("Error buscando el RUT");
        return;
      }

      const data = await resp.json();

      // resultados tal como vienen del backend (sin filtrar por tab)
      const itemsAll = (data.items || []).map((it) => {
        const label =
          it.tipo === "NATURAL"
            ? `${it.nombre || ""} — ${it.rut || ""}`.trim()
            : `${it.razonSocial || ""} — ${it.rut || ""}`.trim();

        return {
          id: it.id,
          tipo: it.tipo,
          rut: it.rut,
          nombre: it.nombre,
          razonSocial: it.razonSocial,
          label,
        };
      });

      // Aplicar filtro por pestaña
      let items = itemsAll;
      if (tipoFromTab) {
        items = itemsAll.filter(
          (it) => (it.tipo || "").toUpperCase() === tipoFromTab
        );
      }

      // Detectar caso "existe pero es de otro tipo"
      let crossTypeMsg = "";

      if (tipoFromTab && items.length === 0 && itemsAll.length > 0) {
        const tiposEncontrados = [
          ...new Set(itemsAll.map((it) => (it.tipo || "").toUpperCase())),
        ];

        const esNatural = tipoFromTab === "NATURAL";
        const hayJuridica = tiposEncontrados.includes("JURIDICA");
        const hayNatural = tiposEncontrados.includes("NATURAL");

        if (isRut) {
          if (esNatural && hayJuridica) {
            crossTypeMsg =
              "El RUT existe pero corresponde a una persona jurídica. Cambia a la pestaña JURÍDICAS para relacionarla.";
          } else if (!esNatural && hayNatural) {
            crossTypeMsg =
              "El RUT existe pero corresponde a una persona natural. Cambia a la pestaña NATURALES para relacionarla.";
          } else {
            crossTypeMsg =
              "El RUT existe pero no es del tipo de esta pestaña. Cambia de pestaña para relacionarlo.";
          }
        } else {
          if (esNatural && hayJuridica) {
            crossTypeMsg =
              "La persona existe pero corresponde a una persona jurídica. Cambia a la pestaña JURÍDICAS para relacionarla.";
          } else if (!esNatural && hayNatural) {
            crossTypeMsg =
              "La persona existe pero corresponde a una persona natural. Cambia a la pestaña NATURALES para relacionarla.";
          } else {
            crossTypeMsg =
              "Se encontraron personas, pero ninguna del tipo de esta pestaña. Prueba cambiando de pestaña.";
          }
        }
      }

      setPersonSugs(items);

      if (crossTypeMsg) {
        // Hay alguien, pero de otro tipo → mostramos mensaje y NO mostramos formulario de creación.
        setNoResults(false);
        setRutBusquedaError(crossTypeMsg);
      } else {
        // Caso normal
        setNoResults(items.length === 0);

        if (isRut) {
          if (itemsAll.length === 0) {
            // aquí sí: realmente no existe en ningún tipo
            setRutBusquedaError("El RUT no existe");
          } else {
            setRutBusquedaError("");
          }
        } else {
          setRutBusquedaError("");
        }
      }
    } catch (e) {
      console.error(e);
      setPersonSugs([]);
      setNoResults(true);
      if (isRut) setRutBusquedaError("Error buscando el RUT");
    } finally {
      setPersonSearchLoading(false);
    }
  };

  const fetchContactos = async () => {
    try {
      const r = await fetch(`${baseUrl}relaciones/lista/${id}`, {
        credentials: "include",
      });
      if (!r.ok) throw new Error(await r.text());
      const data = await r.json();
      const items = data.items || [];

      const nat = [];
      const jur = [];

      items.forEach((it) => {
        const tipo = (it.tipo || "").toUpperCase();

        const tipoRelacionLabel =
          it.tipoRelacion?.descripcion || it.tipoRelacion?.codigo || "";

        const primerCorreo = (it.correos && it.correos[0]) || null;
        const primerTelefono = (it.telefonos && it.telefonos[0]) || null;
        const primeraDir = (it.direcciones && it.direcciones[0]) || null;

        const email = primerCorreo?.email || "";
        const phone = primerTelefono?.numero || "";
        const ubicacion = primeraDir
          ? `${primeraDir.comuna || ""}${
              primeraDir.ciudad ? `, ${primeraDir.ciudad}` : ""
            }`
          : "";

        const baseObj = {
          id: it.personaId,
          personaId: it.personaId,
          relacionId: it.relacionId,
          rut: it.rut || "—",
          tipoRelacion: it.tipoRelacion || null,
          tipoRelacionLabel,
          correos: it.correos || [],
          telefonos: it.telefonos || [],
          direcciones: it.direcciones || [],
          email,
          phone,
          ubicacion,
        };

        if (tipo === "NATURAL") {
          nat.push({
            ...baseObj,
            nombre: it.nombre || "—",
          });
        } else if (tipo === "JURIDICA") {
          jur.push({
            ...baseObj,
            nombre: it.razonSocial || "—",
          });
        }
      });

      setRelNaturales(nat);
      setRelJuridicas(jur);
    } catch (e) {
      console.error("No se pudo cargar relacionados:", e);
      setRelNaturales([]);
      setRelJuridicas([]);
      notifyError("No se pudieron cargar los contactos relacionados.");
    }
  };

  const fetchTiposDireccion = async () => {
    try {
      const resp = await fetch(`${baseUrl}direcciones/tipos`, {
        credentials: "include",
      });
      if (!resp.ok) throw new Error(await resp.text());
      const data = await resp.json();

      const opts = (data.items || []).map((t) => ({
        label: t.descripcion || t.codigo,
        value: t.id,
      }));

      setTiposDireccion(opts);
      setTipoSeleccionado(opts[0]?.value || null);
    } catch (e) {
      console.error("Error cargando tipos de dirección:", e);
      setTiposDireccion([]);
    }
  };

  const fetchDirecciones = async (query) => {
    if (!query || query.length < 3) {
      setDirSugs([]);
      setDirLoading(false);
      return;
    }

    setDirLoading(true);

    try {
      const [calle = "", numero = "", ...rest] = query.split(" ");
      const comuna = rest.join(" ");

      const url = `${baseUrl}direcciones/buscar?calle=${encodeURIComponent(
        calle
      )}&numero=${encodeURIComponent(numero)}&comuna=${encodeURIComponent(
        comuna
      )}&pais=Chile`;

      const resp = await fetch(url, { credentials: "include" });
      if (!resp.ok) throw new Error(await resp.text());

      const data = await resp.json();
      const list = data?.direcciones || [];

      setDirSugs(list);
    } catch (e) {
      console.error(e);
      setDirSugs([]);
    } finally {
      setDirLoading(false);
    }
  };

  const fetchDireccionesPersona = async (personaId) => {
    const resp = await fetch(`${baseUrl}direcciones/lista/${personaId}`, {
      credentials: "include",
    });
    if (!resp.ok) {
      const txt = await resp.text();
      throw new Error(txt || "Error listando direcciones");
    }
    const data = await resp.json();

    return (data.items || []).map((d) => {
      const tipoLabel =
        d.tipoDireccion?.descripcion || d.tipoDireccion?.codigo || "";

      return {
        id: d.direccionId ?? d.id,
        personaDireccionId: d.personaDireccionId,
        calle: d.calle,
        numero: d.numero,
        direccion: d.direccion,
        comuna: d.comuna,
        ciudad: d.ciudad,
        region: d.region,
        pais: d.pais,
        postal: d.postal,
        lat: d.lat,
        lng: d.lng,
        tipoDireccion: d.tipoDireccion,
        tipoDireccionLabel: tipoLabel,
        vigente: d.vigente,
        vigenteDesde: d.vigenteDesde,
        vigenteHasta: d.vigenteHasta,
        principal: d.principal ?? d.isPrincipal ?? false,
      };
    });
  };

  const loadExistingPersonaData = async (personaId) => {
    try {
      const [dirs, mails, tels] = await Promise.all([
        fetchDireccionesPersona(personaId).catch(() => []),
        fetchCorreos(personaId).catch(() => []),
        fetchTelefonos(personaId).catch(() => []),
      ]);

      setExistingData({
        direcciones: (dirs || []).filter((d) => d?.vigente === true),
        correos: (mails || []).filter((c) => c?.vigente === true),
        telefonos: (tels || []).filter((t) => t?.vigente === true),
      });

      setSelectedRelacion({
        direcciones: [],
        correos: [],
        telefonos: [],
      });
    } catch (e) {
      console.error("Error cargando información de persona existente", e);
    }
  };

  // Cargar tipos de relaciones
  useEffect(() => {
    const shouldLoad = addOpen && (activeTab === 0 || activeTab === 1);
    if (!shouldLoad) return;

    let abort = false;
    (async () => {
      try {
        setTiposRelLoading(true);
        setTiposRelError("");
        const resp = await fetch(`${baseUrl}relaciones/tipos`, {
          credentials: "include",
        });
        if (!resp.ok) throw new Error(await resp.text());
        const data = await resp.json();
        const opts = (data.items || []).map((t) => ({
          label: t.descripcion || t.codigo,
          value: t.id,
        }));
        if (!abort) {
          setTiposRel(opts);
          setTipoRelacionId((prev) => prev ?? opts[0]?.value ?? null);
        }
      } catch (e) {
        console.error(e);
        if (!abort)
          setTiposRelError("No se pudieron cargar los tipos de relación");
      } finally {
        if (!abort) setTiposRelLoading(false);
      }
    })();
    return () => {
      abort = true;
    };
  }, [addOpen, activeTab, baseUrl]);

  // ===================== Carga del contacto =====================
  useEffect(() => {
    let abort = false;

    const load = async () => {
      setLoading(true);
      try {
        // 1) Cargar persona
        const resp = await fetch(`${baseUrl}persona/${id}`, {
          credentials: "include",
        });
        if (!resp.ok) {
          const txt = await resp.text();
          throw new Error(txt || "Error cargando persona");
        }
        const data = await resp.json();
        if (abort) return;

        setPersona(data);

        await fetchPersonas();

        await fetchContactos();

        // 2) Cargar direcciones, correos y teléfonos en paralelo
        const [emailsData, telsData, dirsData] = await Promise.all([
          fetchCorreos(id).catch((e) => {
            console.error("Correos:", e);
            return [];
          }),
          fetchTelefonos(id).catch((e) => {
            console.error("Teléfonos:", e);
            return [];
          }),
          fetchDireccionesPersona(id).catch((e) => {
            console.error("Direcciones:", e);
            return [];
          }),
        ]);

        if (abort) return;

        setEmails(emailsData);
        setTelefonos(telsData);
        setDirecciones(dirsData);
      } catch (e) {
        console.error(e);
        notifyError("Error cargando el contacto.");
      } finally {
        if (!abort) setLoading(false);
      }
    };

    if (baseUrl && id) load();
    return () => {
      abort = true;
    };
  }, [id, baseUrl]);

  useEffect(() => {
    if (addOpen && activeTab === 2) {
      fetchTiposDireccion();
    }
  }, [addOpen, activeTab]);

  useEffect(() => {
    if (addOpen && showDirExtra) {
      fetchTiposDireccion();
    }
  }, [addOpen, showDirExtra]);

  // Cargar info de la persona B + estado inicial de la relación
  useEffect(() => {
    if (!detailOpen || !detailContacto?.id) return;

    let abort = false;

    (async () => {
      try {
        const personaBId = detailContacto.id; // 👈 persona relacionada (B)

        const [dirs, mails, tels] = await Promise.all([
          fetchDireccionesPersona(personaBId).catch(() => []),
          fetchCorreos(personaBId).catch(() => []),
          fetchTelefonos(personaBId).catch(() => []),
        ]);

        if (abort) return;

        // Todos los datos que tiene la persona B
        setRelationExistingData({
          direcciones: (dirs || []).filter((d) => d?.vigente === true),
          correos: (mails || []).filter((c) => c?.vigente === true),
          telefonos: (tels || []).filter((t) => t?.vigente === true),
        });

        // Datos actuales de la relación A <-> B
        const currentCorreos = detailContacto.correos || [];
        const currentTelefonos = detailContacto.telefonos || [];
        const currentDirecciones = detailContacto.direcciones || [];

        setRelationWorking({
          correos: currentCorreos,
          telefonos: currentTelefonos,
          direcciones: currentDirecciones,
        });

        // IDs originales que la relación tenía
        setRelationInitialIds({
          correos: currentCorreos.map((c) => c.id),
          telefonos: currentTelefonos.map((t) => t.id),
          direcciones: currentDirecciones.map((d) => d.id),
        });

        // No hay cambios todavía
        setRelationToAdd({
          correos: [],
          telefonos: [],
          direcciones: [],
        });
        setRelationToRemove({
          correos: [],
          telefonos: [],
          direcciones: [],
        });

        setSelectedAddCorreoId(null);
        setSelectedAddTelefonoId(null);
        setSelectedAddDireccionId(null);

        setIsEditingRelation(false);
        setRelationError("");
      } catch (e) {
        console.error("Error cargando datos de persona relacionada", e);
      }
    })();

    return () => {
      abort = true;
    };
  }, [detailOpen, detailContacto]);

  useEffect(() => {
    if (!persona?.id) return;
    fetchFotoPerfil(persona.id);
  }, [persona?.id, baseUrl]);

  useEffect(() => {
    if (!baseUrl) return;

    const ids = [
      ...(relNaturales || []).map((x) => x.personaId || x.id).filter(Boolean),
      ...(relJuridicas || []).map((x) => x.personaId || x.id).filter(Boolean),
    ];

    const uniqueIds = Array.from(new Set(ids));

    uniqueIds.forEach((pid) => {
      fetchFotosPerfil(pid);
    });
  }, [baseUrl, relNaturales, relJuridicas]);

  const guardarDireccion = async () => {
    if (!dirSelected) {
      setSaveError("Debes seleccionar una dirección de la lista.");
      return;
    }

    if (!tipoSeleccionado) {
      setSaveError("Debes seleccionar un tipo de dirección.");
      return;
    }

    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, "0");
    const dd = String(hoy.getDate()).padStart(2, "0");
    const hoyStr = `${yyyy}-${mm}-${dd}`;

    const payload = {
      calle: dirSelected.calle,
      numero: dirSelected.numero,
      comuna: dirSelected.comuna,
      ciudad: dirSelected.ciudad,
      region: dirSelected.region,
      pais: dirSelected.pais,
      postal: dirSelected.postal,
      lat: dirSelected.lat,
      lng: dirSelected.lng,
      raw: JSON.stringify(dirSelected),
      tipoDireccionId: tipoSeleccionado,
      vigente: true,
      vigenteDesde: hoyStr,
      vigenteHasta: null,
    };

    const resp = await fetch(`${baseUrl}direcciones/agregar/${id}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!resp.ok) {
      throw new Error(await resp.text());
    }

    const dirs = await fetchDireccionesPersona(id);
    setDirecciones(dirs);

    setDirSelected(null);
    setDirQuery("");
    setTipoSeleccionado(null);
  };

  // ===================== Filtro local (texto) =====================
  const applyFilter = (arr, fields) => {
    if (!debounced) return arr;
    const q = debounced.toLowerCase();
    return arr.filter((row) =>
      fields.some((f) =>
        String(row[f] ?? "")
          .toLowerCase()
          .includes(q)
      )
    );
  };

  const listNaturales = useMemo(
    () =>
      applyFilter(relNaturales, [
        "nombre",
        "rut",
        "tipoRelacionLabel",
        "email",
        "phone",
        "ubicacion",
      ]),
    [relNaturales, debounced]
  );

  const listJuridicas = useMemo(
    () =>
      applyFilter(relJuridicas, [
        "nombre",
        "rut",
        "tipoRelacionLabel",
        "email",
        "phone",
        "ubicacion",
      ]),
    [relJuridicas, debounced]
  );

  const listEmails = useMemo(
    () => applyFilter(emails, ["email", "etiqueta"]),
    [emails, debounced]
  );

  const listTels = useMemo(
    () => applyFilter(telefonos, ["numero", "etiqueta"]),
    [telefonos, debounced]
  );

  const listDirs = useMemo(
    () =>
      applyFilter(direcciones, [
        "direccion", // texto completo, ej: "Av. Siempre Viva 742..."
        "calle",
        "comuna",
        "ciudad",
        "pais",
        "tipoDireccionLabel", // buscar por tipo: "Casa", "Oficina", etc.
      ]),
    [direcciones, debounced]
  );

  const [existingData, setExistingData] = useState({
    correos: [],
    telefonos: [],
    direcciones: [],
  });

  const [selectedRelacion, setSelectedRelacion] = useState({
    correos: [],
    telefonos: [],
    direcciones: [],
  });

  // Datos completos de la persona B (relacionada)
  const [relationExistingData, setRelationExistingData] = useState({
    correos: [],
    telefonos: [],
    direcciones: [],
  });

  // ¿Estoy editando la relación?
  const [isEditingRelation, setIsEditingRelation] = useState(false);

  // Datos de la relación que se están editando (lo que se muestra en el diálogo)
  const [relationWorking, setRelationWorking] = useState({
    correos: [],
    telefonos: [],
    direcciones: [],
  });

  // IDs originales que tenía la relación al abrir el diálogo
  const [relationInitialIds, setRelationInitialIds] = useState({
    correos: [],
    telefonos: [],
    direcciones: [],
  });

  // Lo que se agregará / quitará (solo IDs)
  const [relationToAdd, setRelationToAdd] = useState({
    correos: [],
    telefonos: [],
    direcciones: [],
  });

  const [relationToRemove, setRelationToRemove] = useState({
    correos: [],
    telefonos: [],
    direcciones: [],
  });

  const [relationSaving, setRelationSaving] = useState(false);
  const [relationError, setRelationError] = useState("");

  // selección en los combos "agregar"
  const [selectedAddCorreoId, setSelectedAddCorreoId] = useState(null);
  const [selectedAddTelefonoId, setSelectedAddTelefonoId] = useState(null);
  const [selectedAddDireccionId, setSelectedAddDireccionId] = useState(null);

  const [emailDetailOpen, setEmailDetailOpen] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);

  const [phoneDetailOpen, setPhoneDetailOpen] = useState(false);
  const [selectedPhone, setSelectedPhone] = useState(null);

  const [addressDetailOpen, setAddressDetailOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const [deleting, setDeleting] = useState(false);

  // ===================== Encabezado =====================
  const headerName = useMemo(() => {
    if (!persona) return "—";

    const t = (persona.tipo || "").toUpperCase();

    if (t === "JURIDICA") {
      return persona.razonSocial || "—";
    }

    if (t === "LEAD") {
      return (
        persona.descripcionLead ||
        persona.leadDescripcion ||
        persona.descripcion ||
        "—"
      );
    }

    const p = [
      persona.primerNombre,
      persona.segundoNombre,
      persona.apellidoPaterno,
      persona.apellidoMaterno,
    ]
      .filter(Boolean)
      .join(" ");

    return p || "—";
  }, [persona]);

  const tipoPersonaLabel = useMemo(() => {
    if (!persona) return "";
    const t = (persona.tipo || "").toUpperCase();
    if (t === "JURIDICA") return "Persona Jurídica";
    if (t === "NATURAL") return "Persona Natural";
    if (t === "LEAD") return "Lead";
    return persona.tipo || "";
  }, [persona]);

  const primaryEmail = useMemo(() => {
    if (!emails?.length) return null;
    return emails.find((e) => e.principal) || emails[0];
  }, [emails]);

  const primaryPhone = useMemo(() => {
    if (!telefonos?.length) return null;
    return telefonos.find((t) => t.principal) || telefonos[0];
  }, [telefonos]);

  const primaryAddress = useMemo(() => {
    if (!direcciones?.length) return null;
    return direcciones.find((d) => d.principal) || direcciones[0];
  }, [direcciones]);

  const primaryAddressLabel = useMemo(() => {
    if (!primaryAddress) return "—";
    const { calle, numero, comuna, ciudad, pais } = primaryAddress;
    const line1 = [calle, numero].filter(Boolean).join(" ");
    const line2 = [comuna, ciudad, pais].filter(Boolean).join(", ");
    return [line1, line2].filter(Boolean).join(" — ");
  }, [primaryAddress]);

  // ===================== Botón Añadir dinámico =====================

  const addLabels = ["Natural", "Jurídica", "Dirección", "Correo", "Teléfono"];

  const onClickAdd = () => {
    setAddData({});
    setPersonQuery("");
    setPersonSugs([]);
    setPersonSelected(null);
    setNoResults(false);
    setTipoRelacionId(null);
    setTiposRelError("");

    // reset formulario NATURAL
    setForm({
      primerNombre: "",
      segundoNombre: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      fechaNacimiento: null,
      genero: "",
    });
    setErrors({});

    // reset extras
    setShowDirExtra(false);
    setShowCorreoExtra(false);
    setShowTelefonoExtra(false);
    setDirExtra({ calle: "", comuna: "", ciudad: "", pais: "" });
    setCorreoExtra({ email: "", etiqueta: "" });
    setTelExtra({ numero: "", etiqueta: "" });
    setPhoneCountryCode("+56");

    setAddOpen(true);
  };

  const toIsoDate = (d) => {
    if (!d) return null;
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const parseIsoDate = (s) => {
    if (!s) return null;
    const parts = s.split("-");
    if (parts.length !== 3) return null;
    const [y, m, d] = parts.map((n) => parseInt(n, 10));
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  };

  const cleanRut = (rut) =>
    (rut || "").replace(/\./g, "").replace(/-/g, "").toUpperCase();

  const formatRut = (raw = "") => {
    let clean = cleanRut(raw);
    if (!clean) return "";

    const dv = clean.slice(-1);
    let body = clean.slice(0, -1);

    if (!/^\d+$/.test(body)) return raw;

    let result = "";
    while (body.length > 3) {
      result = "." + body.slice(-3) + result;
      body = body.slice(0, -3);
    }
    result = body + result;

    return `${result}-${dv}`;
  };

  const isValidRut = (rut) => {
    const clean = cleanRut(rut);
    if (!clean || clean.length < 2) return false;

    const body = clean.slice(0, -1);
    const dv = clean.slice(-1);

    if (!/^\d+$/.test(body)) return false;

    let sum = 0;
    let multiplier = 2;

    for (let i = body.length - 1; i >= 0; i--) {
      sum += parseInt(body[i], 10) * multiplier;
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const rest = 11 - (sum % 11);
    let dvEsperado;

    if (rest === 11) dvEsperado = "0";
    else if (rest === 10) dvEsperado = "K";
    else dvEsperado = String(rest);

    return dv === dvEsperado;
  };

  const prettyRut = (rut) => (rut || "").toUpperCase();

  const onSaveAdd = async () => {
    if (saving) return;
    try {
      setSaveError("");
      setSaving(true);

      const todayIso = () => {
        const hoy = new Date();
        const yyyy = hoy.getFullYear();
        const mm = String(hoy.getMonth() + 1).padStart(2, "0");
        const dd = String(hoy.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      // ===== PERSONAS (0: NATURAL, 1: JURÍDICA) =====
      if (activeTab === 0 || activeTab === 1) {
        // Validar tipo de relación obligatorio
        if (!tipoRelacionId) {
          setSaveError("Debes seleccionar el tipo de relación.");
          return;
        }

        // Caso: PERSONA EXISTENTE (seleccionada del autosuggest)
        if (addData.personaRelacionadaId) {
          const correosSel = Array.isArray(selectedRelacion.correos)
            ? selectedRelacion.correos
            : selectedRelacion.correos
            ? [selectedRelacion.correos]
            : [];

          const telsSel = Array.isArray(selectedRelacion.telefonos)
            ? selectedRelacion.telefonos
            : selectedRelacion.telefonos
            ? [selectedRelacion.telefonos]
            : [];

          const dirsSel = Array.isArray(selectedRelacion.direcciones)
            ? selectedRelacion.direcciones
            : selectedRelacion.direcciones
            ? [selectedRelacion.direcciones]
            : [];

          const payload = {
            personaRelacionadaId: addData.personaRelacionadaId,
            tipoRelacionId,

            correoIds: correosSel.filter((id) => id != null),
            telefonoIds: telsSel.filter((id) => id != null),
            direccionIds: dirsSel.filter((id) => id != null),
          };

          const resp = await fetch(`${baseUrl}contacto/crear/${id}`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });

          if (!resp.ok) throw new Error(await resp.text());

          await fetchContactos();
          setAddOpen(false);
          return;
        }

        // Caso: NO RESULTADOS -> crear + activar + relacionar
        if (noResults && personQuery) {
          const tipo = tipoFromTab;

          const correosNuevos = [];
          const telefonosNuevos = [];
          const direccionesNuevas = [];

          // CORREO NUEVO
          if (showCorreoExtra && (addData.email || "").trim()) {
            correosNuevos.push({
              email: (addData.email || "").trim(),
              etiqueta: (addData.etiqueta || "").trim() || null,
              principal: false,
              vigente: true,
              verificado: false,
              vigenteDesde: todayIso(),
              vigenteHasta: null,
            });
          }

          // TELÉFONO NUEVO
          if (showTelefonoExtra && (addData.numero || "").trim()) {
            const localNumber = (addData.numero || "").trim();
            const fullPhone =
              phoneCountryCode && localNumber
                ? `${phoneCountryCode} ${localNumber}`
                : localNumber;

            telefonosNuevos.push({
              telefono: fullPhone,
              etiqueta: (addData.etiqueta || "").trim() || null,
              principal: false,
              vigente: true,
              verificado: false,
              vigenteDesde: todayIso(),
              vigenteHasta: null,
            });
          }

          // DIRECCIÓN NUEVA
          if (showDirExtra && addData.direccionSeleccionada) {
            const d = addData.direccionSeleccionada;
            if (
              showDirExtra &&
              addData.direccionSeleccionada &&
              !addData.tipoDireccionId
            ) {
              setSaveError("Debes seleccionar un tipo de dirección.");
              return;
            }
            direccionesNuevas.push({
              calle: d.calle,
              numero: d.numero,
              direccion: d.direccion,
              comuna: d.comuna,
              ciudad: d.ciudad,
              region: d.region,
              pais: d.pais || "Chile",
              postal: d.postal,
              lat: d.lat,
              lng: d.lng,
              raw: JSON.stringify(d),

              vigente: true,
              vigenteDesde: todayIso(),
              vigenteHasta: null,
              tipoDireccionId: addData.tipoDireccionId,
            });
          }

          if (tipo === "NATURAL") {
            // Validación mínima NATURAL
            const errs = {};
            if (!nuevo.nacionalidad) errs.nacionalidad = "Requerido";
            if (!form.primerNombre?.trim()) errs.primerNombre = "Requerido";
            if (!form.apellidoPaterno?.trim())
              errs.apellidoPaterno = "Requerido";
            if (!form.apellidoMaterno?.trim())
              errs.apellidoMaterno = "Requerido";
            if (form.fechaNacimiento && form.fechaNacimiento > today) {
              errs.fechaNacimiento = "La fecha no puede ser futura";
            }
            if (!form.genero) errs.genero = "Requerido";
            if (nuevo.rut && !isValidRut(nuevo.rut)) {
              errs.rut = "RUT inválido";
            }
            setErrors(errs);
            if (Object.keys(errs).length > 0) {
              setSaveError("Completa los campos obligatorios.");
              return;
            }

            const payload = {
              tipo: "NATURAL",
              rut: cleanRut(nuevo.rut) || null,
              nacionalidad: nuevo.nacionalidad || null,
              primerNombre: form.primerNombre,
              segundoNombre: form.segundoNombre || null,
              apellidoPaterno: form.apellidoPaterno,
              apellidoMaterno: form.apellidoMaterno,
              genero: form.genero,
              fechaNacimiento: toIsoDate(form.fechaNacimiento),
              tipoRelacionId,
              correosNuevos,
              telefonosNuevos,
              direccionesNuevas,
            };

            const r = await fetch(`${baseUrl}contacto/crear/${id}`, {
              method: "POST",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            });
            if (!r.ok) throw new Error(await r.text());

            await fetchContactos();
            setAddOpen(false);
            return;
          } else {
            // JURÍDICA
            const errs = {};
            if (!nuevo.razonSocial?.trim()) {
              setSaveError("Razón social es obligatoria.");
              return;
            }
            if (nuevo.rut && !isValidRut(nuevo.rut)) {
              errs.rut = "RUT inválido";
            }

            if (Object.keys(errs).length > 0) {
              setErrors((prev) => ({ ...prev, ...errs }));
              setSaveError("Corrige los errores del formulario.");
              return;
            }

            const payload = {
              tipo: "JURIDICA",
              rut: cleanRut(nuevo.rut) || null,
              nacionalidad: nuevo.nacionalidad || null,
              razonSocial: nuevo.razonSocial,
              tipoRelacionId,
              correosNuevos,
              telefonosNuevos,
              direccionesNuevas,
            };

            const r = await fetch(`${baseUrl}contacto/crear/${id}`, {
              method: "POST",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            });
            if (!r.ok) throw new Error(await r.text());

            await fetchContactos();
            setAddOpen(false);
            return;
          }
        }

        // Si no hay selección ni creación
        setSaveError(
          "Selecciona una persona o completa el formulario para crearla."
        );
        return;
      }

      // ===== DIRECCIONES (2) =====
      if (activeTab === 2) {
        try {
          await guardarDireccion();
          setAddOpen(false);
        } catch (e) {
          setSaveError("No se pudo guardar la dirección: " + e.message);
        }
        return;
      }

      // ===== CORREOS (3) =====
      if (activeTab === 3) {
        const payload = {
          email: addData.email,
          etiqueta: addData.etiqueta || null,
          principal: false,
          vigente: true,
          verificado: false,
          vigenteDesde: todayIso(),
          vigenteHasta: null,
        };
        const r = await fetch(`${baseUrl}correo/agregar/${id}`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        if (!r.ok) throw new Error(await r.text());

        const correos = await fetchCorreos(id);
        setEmails(correos);

        setAddData({});
        setAddOpen(false);
        return;
      }

      // ===== TELÉFONOS (4) =====
      // ===== TELÉFONOS (4) =====
      if (activeTab === 4) {
        const hoy = todayIso();

        const localNumber = (addData.numero || "").trim();
        const fullPhone =
          phoneCountryCode && localNumber
            ? `${phoneCountryCode} ${localNumber}`
            : localNumber;

        const payload = {
          telefono: fullPhone,
          etiqueta: addData.etiqueta?.trim() || null,
          principal: false,
          vigente: true,
          verificado: false,
          vigenteDesde: hoy,
          vigenteHasta: null,
        };

        const r = await fetch(`${baseUrl}telefono/agregar/${id}`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        if (!r.ok) throw new Error(await r.text());

        const telefonos = await fetchTelefonos(id);
        setTelefonos(telefonos);
        setAddData({});
        setAddOpen(false);
        return;
      }
    } catch (e) {
      console.error(e);
      const msg = "No se pudo guardar. " + (e?.message || "");
      setSaveError(msg);
      notifyError(msg);
    } finally {
      setSaving(false);
    }
  };

  // ===================== Toolbar (Buscar / Añadir / Vista / Filtros) =====================
  const left = (
    <div className="flex items-center gap-2 w-full">
      <Button
        label="Añadir"
        icon="pi pi-plus"
        onClick={onClickAdd}
        className="flex-none"
      />
      <span className="p-input-icon-left flex-1 min-w-0">
        <i className="pi pi-search" />
        <InputText
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar por nombre, RUT o tipo de relación, Tipo de dirección, Correo, Teléfono …"
          className="w-full"
        />
      </span>
    </div>
  );

  const viewOptions = [
    { label: "Kanban", value: "kanban", icon: "pi pi-th-large" },
    { label: "Lista", value: "lista", icon: "pi pi-list" },
  ];

  const right = (
    <div className="flex items-center gap-2">
      <SelectButton
        value={view}
        onChange={(e) => setView(e.value)}
        options={viewOptions}
        allowEmpty={false}
        itemTemplate={(o) => <i className={`${o.icon} text-lg`} />}
      />
      {/*<Button
        label="Filtros"
        icon="pi pi-sliders-h"
        outlined
        onClick={() => setFiltersOpen(true)}
      />*/}
    </div>
  );

  const handleRelacionClick = (contacto) => {
    setDetailContacto(contacto);
    setDetailOpen(true);
  };

  const handleEmailClick = (email) => {
    setSelectedEmail(email);
    setEmailDetailOpen(true);
  };

  const handlePhoneClick = (phone) => {
    setSelectedPhone(phone);
    setPhoneDetailOpen(true);
  };

  const handleAddressClick = (address) => {
    setSelectedAddress(address);
    setAddressDetailOpen(true);
  };

  const handleStartEditRelation = () => {
    setIsEditingRelation(true);
    setRelationError("");
  };

  const handleCancelEditRelation = () => {
    // Volver al estado original de la relación (lo que vino en detailContacto)
    setRelationWorking({
      correos: detailContacto?.correos || [],
      telefonos: detailContacto?.telefonos || [],
      direcciones: detailContacto?.direcciones || [],
    });
    setRelationToAdd({
      correos: [],
      telefonos: [],
      direcciones: [],
    });
    setRelationToRemove({
      correos: [],
      telefonos: [],
      direcciones: [],
    });
    setSelectedAddCorreoId(null);
    setSelectedAddTelefonoId(null);
    setSelectedAddDireccionId(null);
    setIsEditingRelation(false);
    setRelationError("");
  };

  const handleRemoveCorreoFromRelation = (correoId) => {
    setRelationWorking((prev) => ({
      ...prev,
      correos: prev.correos.filter((c) => c.id !== correoId),
    }));

    setRelationToAdd((prev) => ({
      ...prev,
      correos: prev.correos.filter((id) => id !== correoId),
    }));

    // Si estaba originalmente en la relación, ahora pasa a "quitar"
    if (relationInitialIds.correos.includes(correoId)) {
      setRelationToRemove((prev) => ({
        ...prev,
        correos: prev.correos.includes(correoId)
          ? prev.correos
          : [...prev.correos, correoId],
      }));
    }
  };

  const handleRemoveTelefonoFromRelation = (telefonoId) => {
    setRelationWorking((prev) => ({
      ...prev,
      telefonos: prev.telefonos.filter((t) => t.id !== telefonoId),
    }));

    setRelationToAdd((prev) => ({
      ...prev,
      telefonos: prev.telefonos.filter((id) => id !== telefonoId),
    }));

    if (relationInitialIds.telefonos.includes(telefonoId)) {
      setRelationToRemove((prev) => ({
        ...prev,
        telefonos: prev.telefonos.includes(telefonoId)
          ? prev.telefonos
          : [...prev.telefonos, telefonoId],
      }));
    }
  };

  const handleRemoveDireccionFromRelation = (direccionId) => {
    setRelationWorking((prev) => ({
      ...prev,
      direcciones: prev.direcciones.filter((d) => d.id !== direccionId),
    }));

    setRelationToAdd((prev) => ({
      ...prev,
      direcciones: prev.direcciones.filter((id) => id !== direccionId),
    }));

    if (relationInitialIds.direcciones.includes(direccionId)) {
      setRelationToRemove((prev) => ({
        ...prev,
        direcciones: prev.direcciones.includes(direccionId)
          ? prev.direcciones
          : [...prev.direcciones, direccionId],
      }));
    }
  };

  const handleAddCorreoToRelation = () => {
    if (!selectedAddCorreoId) return;

    // ya está en la relación?
    if (relationWorking.correos.some((c) => c.id === selectedAddCorreoId)) {
      setSelectedAddCorreoId(null);
      return;
    }

    const correoObj = relationExistingData.correos.find(
      (c) => c.id === selectedAddCorreoId
    );
    if (!correoObj) return;

    setRelationWorking((prev) => ({
      ...prev,
      correos: [...prev.correos, correoObj],
    }));

    if (!relationInitialIds.correos.includes(selectedAddCorreoId)) {
      setRelationToAdd((prev) => ({
        ...prev,
        correos: prev.correos.includes(selectedAddCorreoId)
          ? prev.correos
          : [...prev.correos, selectedAddCorreoId],
      }));
    }

    // por si estaba marcado para quitar y lo vuelven a agregar
    setRelationToRemove((prev) => ({
      ...prev,
      correos: prev.correos.filter((id) => id !== selectedAddCorreoId),
    }));

    setSelectedAddCorreoId(null);
  };

  const handleAddTelefonoToRelation = () => {
    if (!selectedAddTelefonoId) return;

    if (relationWorking.telefonos.some((t) => t.id === selectedAddTelefonoId)) {
      setSelectedAddTelefonoId(null);
      return;
    }

    const telObj = relationExistingData.telefonos.find(
      (t) => t.id === selectedAddTelefonoId
    );
    if (!telObj) return;

    setRelationWorking((prev) => ({
      ...prev,
      telefonos: [...prev.telefonos, telObj],
    }));

    if (!relationInitialIds.telefonos.includes(selectedAddTelefonoId)) {
      setRelationToAdd((prev) => ({
        ...prev,
        telefonos: prev.telefonos.includes(selectedAddTelefonoId)
          ? prev.telefonos
          : [...prev.telefonos, selectedAddTelefonoId],
      }));
    }

    setRelationToRemove((prev) => ({
      ...prev,
      telefonos: prev.telefonos.filter((id) => id !== selectedAddTelefonoId),
    }));

    setSelectedAddTelefonoId(null);
  };

  const handleAddDireccionToRelation = () => {
    if (!selectedAddDireccionId) return;

    if (
      relationWorking.direcciones.some((d) => d.id === selectedAddDireccionId)
    ) {
      setSelectedAddDireccionId(null);
      return;
    }

    const dirObj = relationExistingData.direcciones.find(
      (d) => d.id === selectedAddDireccionId
    );
    if (!dirObj) return;

    setRelationWorking((prev) => ({
      ...prev,
      direcciones: [...prev.direcciones, dirObj],
    }));

    if (!relationInitialIds.direcciones.includes(selectedAddDireccionId)) {
      setRelationToAdd((prev) => ({
        ...prev,
        direcciones: prev.direcciones.includes(selectedAddDireccionId)
          ? prev.direcciones
          : [...prev.direcciones, selectedAddDireccionId],
      }));
    }

    setRelationToRemove((prev) => ({
      ...prev,
      direcciones: prev.direcciones.filter(
        (id) => id !== selectedAddDireccionId
      ),
    }));

    setSelectedAddDireccionId(null);
  };

  const handleSaveRelationContacts = async () => {
    if (!detailContacto?.relacionId) return;

    const hasAdds =
      relationToAdd.correos.length ||
      relationToAdd.telefonos.length ||
      relationToAdd.direcciones.length;

    const hasRemoves =
      relationToRemove.correos.length ||
      relationToRemove.telefonos.length ||
      relationToRemove.direcciones.length;

    if (!hasAdds && !hasRemoves) {
      setRelationError("No hay cambios para guardar.");
      return;
    }

    try {
      setRelationSaving(true);
      setRelationError("");

      // AGREGAR
      if (hasAdds) {
        const respAdd = await fetch(
          `${baseUrl}relaciones/${detailContacto.relacionId}/contactos/agregar`,
          {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              correoIds: relationToAdd.correos,
              telefonoIds: relationToAdd.telefonos,
              direccionIds: relationToAdd.direcciones,
            }),
          }
        );
        if (!respAdd.ok) throw new Error(await respAdd.text());
      }

      // QUITAR
      if (hasRemoves) {
        const respQuit = await fetch(
          `${baseUrl}relaciones/${detailContacto.relacionId}/contactos/quitar`,
          {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              correoIds: relationToRemove.correos,
              telefonoIds: relationToRemove.telefonos,
              direccionIds: relationToRemove.direcciones,
            }),
          }
        );
        if (!respQuit.ok) throw new Error(await respQuit.text());
      }

      // refrescar listado de relaciones
      await fetchContactos();

      setDetailOpen(false);
      setDetailContacto(null);
    } catch (e) {
      console.error(e);
      const msg =
        "No se pudieron actualizar los datos de la relación: " +
        (e.message || "");
      setRelationError(msg);
      notifyError(msg);
    } finally {
      setRelationSaving(false);
    }
  };

  const refreshCorreos = async () => {
    const correos = await fetchCorreos(id);
    setEmails(correos);
  };

  const refreshTelefonos = async () => {
    const tels = await fetchTelefonos(id);
    setTelefonos(tels);
  };

  const refreshDirecciones = async () => {
    const dirs = await fetchDireccionesPersona(id);
    setDirecciones(dirs);
  };

  const desactivarCorreo = async () => {
    if (!selectedEmail?.id) return;
    if (!window.confirm("¿Seguro que quieres quitar este correo?")) return;

    try {
      setDeleting(true);
      const resp = await fetch(
        `${baseUrl}correo/desactivar/${id}/${selectedEmail.id}`,
        {
          method: "POST",
          credentials: "include",
        }
      );
      if (!resp.ok) throw new Error(await resp.text());

      await refreshCorreos();
      setEmailDetailOpen(false);
      setSelectedEmail(null);
    } catch (e) {
      console.error(e);
      notifyError("No se pudo quitar el correo: " + (e.message || ""));
    } finally {
      setDeleting(false);
    }
  };

  const activarCorreo = async () => {
    if (!selectedEmail?.id) return;
    if (!window.confirm("¿Seguro que quieres activar este correo?")) return;

    try {
      setDeleting(true);
      const resp = await fetch(
        `${baseUrl}correo/activar/${id}/${selectedEmail.id}`,
        {
          method: "POST",
          credentials: "include",
        }
      );
      if (!resp.ok) throw new Error(await resp.text());

      await refreshCorreos();
      setEmailDetailOpen(false);
      setSelectedEmail(null);
    } catch (e) {
      console.error(e);
      notifyError("No se pudo activar el correo: " + (e.message || ""));
    } finally {
      setDeleting(false);
    }
  };

  const desactivarTelefono = async () => {
    if (!selectedPhone?.id) return;
    if (!window.confirm("¿Seguro que quieres quitar este teléfono?")) return;

    try {
      setDeleting(true);
      const resp = await fetch(
        `${baseUrl}telefono/desactivar/${id}/${selectedPhone.id}`,
        {
          method: "POST",
          credentials: "include",
        }
      );
      if (!resp.ok) throw new Error(await resp.text());

      await refreshTelefonos();
      setPhoneDetailOpen(false);
      setSelectedPhone(null);
    } catch (e) {
      console.error(e);
      notifyError("No se pudo quitar el teléfono: " + (e.message || ""));
    } finally {
      setDeleting(false);
    }
  };

  const activarTelefono = async () => {
    if (!selectedPhone?.id) return;
    if (!window.confirm("¿Seguro que quieres activar este teléfono?")) return;

    try {
      setDeleting(true);
      const resp = await fetch(
        `${baseUrl}telefono/activar/${id}/${selectedPhone.id}`,
        {
          method: "POST",
          credentials: "include",
        }
      );
      if (!resp.ok) throw new Error(await resp.text());

      await refreshTelefonos();
      setPhoneDetailOpen(false);
      setSelectedPhone(null);
    } catch (e) {
      console.error(e);
      notifyError("No se pudo activar el teléfono: " + (e.message || ""));
    } finally {
      setDeleting(false);
    }
  };

  const desactivarDireccion = async () => {
    if (!selectedAddress?.personaDireccionId) return;
    if (!window.confirm("¿Seguro que quieres quitar esta dirección?")) return;

    try {
      setDeleting(true);
      const resp = await fetch(
        `${baseUrl}direcciones/desactivar/persona/${selectedAddress.personaDireccionId}`,
        {
          method: "POST",
          credentials: "include",
        }
      );
      if (!resp.ok) throw new Error(await resp.text());

      await refreshDirecciones();
      setAddressDetailOpen(false);
      setSelectedAddress(null);
    } catch (e) {
      console.error(e);
      notifyError("No se pudo quitar la dirección: " + (e.message || ""));
    } finally {
      setDeleting(false);
    }
  };

  const activarDireccion = async () => {
    if (!selectedAddress?.personaDireccionId) return;
    if (!window.confirm("¿Seguro que quieres activar esta dirección?")) return;

    try {
      setDeleting(true);
      const resp = await fetch(
        `${baseUrl}direcciones/activar/persona/${selectedAddress.personaDireccionId}`,
        {
          method: "POST",
          credentials: "include",
        }
      );
      if (!resp.ok) throw new Error(await resp.text());

      await refreshDirecciones();
      setAddressDetailOpen(false);
      setSelectedAddress(null);
    } catch (e) {
      console.error(e);
      notifyError("No se pudo activar la dirección: " + (e.message || ""));
    } finally {
      setDeleting(false);
    }
  };

  // ===================== Render helpers =====================
  const KanbanCards = ({ data, icon = "pi-user", onCardClick }) => {
    if (loading) {
      return (
        <div className="grid">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="col-12 md:col-4 mb-3">
              <Card className="h-full w-full">
                <div className="flex items-center gap-3">
                  <Skeleton shape="circle" size="4rem" className="mr-2" />
                  <div className="flex-1">
                    <Skeleton width="70%" height="1.2rem" className="mb-2" />
                    <Skeleton width="50%" height="1rem" />
                  </div>
                </div>
              </Card>
            </div>
          ))}
        </div>
      );
    }

    if (!data?.length) {
      return (
        <div className="surface-card p-4 border-2 border-dashed border-300 text-color-secondary text-center rounded-2xl">
          Sin resultados
        </div>
      );
    }

    return (
      <div className="grid">
        {data.map((item) => {
          const isNoVigente = item.vigente === false;

          return (
            <div key={item.id} className="col-12 md:col-4 mb-3">
              <Card
                onClick={() => {
                  if (onCardClick) {
                    onCardClick(item);
                  } else if (item.id) {
                    navigate(`/contactos/${item.id}`);
                  }
                }}
                className={`h-full w-full overflow-hidden cursor-pointer transition-duration-150 hover:shadow-3 ${
                  isNoVigente ? "opacity-60" : ""
                }`}
              >
                <div className="flex gap-3">
                  <div className="flex items-start flex-none">
                    <div className="surface-200 w-5rem h-5rem border-circle overflow-hidden flex align-items-center justify-content-center">
                      {fotoByPersonaId[item.personaId || item.id] ? (
                        <img
                          src={fotoByPersonaId[item.personaId || item.id]}
                          alt="Foto perfil"
                          className="w-full h-full"
                          style={{ objectFit: "cover", display: "block" }}
                        />
                      ) : (
                        <span className="flex align-items-center justify-content-center w-full h-full">
                          <i
                            className="pi pi-user text-2xl text-color-secondary"
                            style={{ lineHeight: 1, display: "block" }}
                          />
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-2 min-w-0">
                      <div className="text-lg font-medium truncate">
                        {item.nombre || item.email || "—"}
                      </div>

                      {isNoVigente && (
                        <Tag
                          value="No vigente"
                          severity="danger"
                          className="text-xs px-2 py-1 border-round-2xl flex-shrink-0"
                        />
                      )}
                    </div>

                    {item.tipoRelacionLabel && (
                      <Tag
                        value={item.tipoRelacionLabel}
                        className="mb-2 text-xs px-2 py-1 border-round-2xl"
                      />
                    )}

                    {item.etiquetaTag && (
                      <div className="mb-2">{item.etiquetaTag}</div>
                    )}

                    {item.email && (
                      <div className="text-sm text-color-secondary truncate">
                        {item.email}
                      </div>
                    )}

                    {item.phone && (
                      <div className="text-sm text-color-secondary break-words">
                        {item.phone}
                      </div>
                    )}

                    {item.ubicacion && (
                      <div className="text-sm text-color-secondary break-words">
                        {item.ubicacion}
                      </div>
                    )}
                  </div>
                </div>
              </Card>
            </div>
          );
        })}
      </div>
    );
  };

  const SimpleList = ({ value, cols, onRowClick }) => (
    <DataTable
      value={value}
      paginator
      rows={10}
      rowsPerPageOptions={[10, 20, 50, 100]}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
      stripedRows
      emptyMessage="Sin resultados"
      className="rounded-2xl overflow-hidden"
      responsiveLayout="stack"
      breakpoint="960px"
      onRowClick={(e) =>
        onRowClick
          ? onRowClick(e.data)
          : e.data?.id && navigate(`/contactos/${e.data.id}`)
      }
    >
      {cols.map((c) => (
        <Column
          key={c.field || c.header}
          field={c.field}
          header={c.header}
          sortable={c.sortable ?? true}
          body={c.body}
          style={c.style}
        />
      ))}
    </DataTable>
  );

  const H = ({ icon, text }) => (
    <span className="flex items-center gap-2">
      <i className={`pi ${icon}`} />
      <span>{text}</span>
    </span>
  );

  // ===================== UI =====================
  return (
    <div className="p-4 md:p-5">
      {/* Encabezado */}
      <div className="flex flex-col gap-4 md:flex-row md:items-start md:gap-6 mb-3">
        {/* Columna izquierda: botón + avatar (avatar solo en desktop) */}
        <div className="flex items-center gap-3">
          <Button
            icon="pi pi-arrow-left"
            rounded
            outlined
            onClick={() => navigate("/contactos")}
          />

          {/* Oculto en mobile, visible desde md */}
          <div className="hidden md:flex surface-200 items-center justify-center w-8rem h-8rem border-circle overflow-hidden">
            {fotoDataUrl ? (
              <img
                src={fotoDataUrl}
                alt="Foto de perfil"
                className="w-full h-full"
                style={{ objectFit: "cover" }}
              />
            ) : (
              <i className="pi pi-user text-5xl text-color-secondary" />
            )}
          </div>
        </div>

        {/* Columna central: info persona (debajo del botón en mobile) */}
        <div className="w-full md:flex-1 md:min-w-0 mt-4 md:mt-0">
          {/* Tipo de persona arriba del nombre */}
          <div className="flex gap-2 flex-wrap">
            <Tag
              value={tipoPersonaLabel || persona?.tipo || "—"}
              severity="info"
              className="text-xs px-3 py-1 border-round-2xl"
            />
          </div>

          {/* Nombre grande + botón Editar */}
          <div className="mt-2 flex flex-wrap items-center gap-3">
            <div className="text-4xl md:text-5xl font-bold truncate">
              {headerName}
            </div>

            <Button
              label="Editar datos"
              icon="pi pi-pencil"
              outlined
              size="small"
              onClick={openEditPersona}
            />
          </div>

          {/* Lista vertical de datos */}
          <div className="mt-3 flex flex-column gap-2 text-sm md:text-base">
            <div>
              <span className="font-medium">
                {(persona?.tipo || "").toUpperCase() === "JURIDICA"
                  ? "Razón social:"
                  : (persona?.tipo || "").toUpperCase() === "LEAD"
                  ? "Descripción lead:"
                  : "Nombre completo:"}
              </span>{" "}
              <span>{headerName}</span>
            </div>

            <div>
              <span className="font-medium">RUT:</span>{" "}
              <span>{persona?.rut ? formatRut(persona.rut) : "—"}</span>
            </div>

            <div>
              <span className="font-medium">Nacionalidad:</span>{" "}
              {personaCountry ? (
                <span className="inline-flex items-center gap-2 align-middle">
                  {countryOptionTemplate(personaCountry)}
                </span>
              ) : (
                <span>—</span>
              )}
            </div>

            <div>
              <span className="font-medium">Correo principal:</span>{" "}
              <span>{primaryEmail?.email || "—"}</span>
            </div>

            <div>
              <span className="font-medium">Teléfono principal:</span>{" "}
              <span>{primaryPhone?.numero || "—"}</span>
            </div>

            <div>
              <span className="font-medium">Dirección principal:</span>{" "}
              <span>{primaryAddressLabel}</span>
            </div>
          </div>
        </div>

        {/* Columna derecha: Más información relevante (solo desktop) */}
        <div className="hidden md:block">
          <Card className="w-22rem p-4">
            <div className="text-base text-color-secondary mb-3 font-medium">
              Más información relevante
            </div>
            <div className="flex gap-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <div
                  key={i}
                  className="surface-200 w-3rem h-3rem border-circle flex items-center justify-center"
                >
                  <i className="pi pi-user text-lg" />
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>

      <Toolbar left={left} right={right} className="rounded-2xl mb-3 w-full" />
      <Divider className="my-4" />

      {/* Tabs */}
      <TabView
        activeIndex={activeTab}
        onTabChange={(e) => setActiveTab(e.index)}
      >
        <TabPanel header={<H icon="pi-user" text="NATURALES" />}>
          {view === "kanban" ? (
            <KanbanCards
              data={listNaturales}
              icon="pi pi-user"
              onCardClick={handleRelacionClick}
            />
          ) : (
            <SimpleList
              value={listNaturales}
              cols={[
                { field: "nombre", header: "Nombre" },
                { field: "tipoRelacionLabel", header: "Relación" },
                { field: "email", header: "Correo" },
                { field: "phone", header: "Teléfono" },
                { field: "ubicacion", header: "Ubicación" },
              ]}
              onRowClick={handleRelacionClick}
            />
          )}
        </TabPanel>
        <TabPanel header={<H icon="pi-briefcase" text="JURÍDICAS" />}>
          {view === "kanban" ? (
            <KanbanCards
              data={listJuridicas}
              icon="pi pi-briefcase"
              onCardClick={handleRelacionClick}
            />
          ) : (
            <SimpleList
              value={listJuridicas}
              cols={[
                { field: "nombre", header: "Razón social" },
                { field: "tipoRelacionLabel", header: "Relación" },
                { field: "email", header: "Correo" },
                { field: "phone", header: "Teléfono" },
                { field: "ubicacion", header: "Ubicación" },
              ]}
              onRowClick={handleRelacionClick}
            />
          )}
        </TabPanel>
        <TabPanel header={<H icon="pi-map-marker" text="DIRECCIONES" />}>
          {view === "kanban" ? (
            <KanbanCards
              data={listDirs.map((d) => ({
                ...d,
                nombre: `${d.calle ?? ""} ${d.numero ?? ""}`.trim(),
                email: `${d.comuna ?? ""}, ${d.ciudad ?? ""}`.trim(),
                phone: d.tipoDireccionLabel ? (
                  <Tag
                    value={d.tipoDireccionLabel}
                    severity="primary"
                    className="text-xs px-2 py-1 border-round-2xl mt-1 "
                  />
                ) : null,
                ubicacion: "",
                vigente: d.vigente,
              }))}
              icon="pi pi-map-marker"
              onCardClick={(card) => handleAddressClick(card)}
            />
          ) : (
            <SimpleList
              value={listDirs}
              cols={[
                { field: "calle", header: "Dirección" },
                { field: "comuna", header: "Comuna" },
                { field: "ciudad", header: "Ciudad" },
                { field: "pais", header: "País" },
                { field: "tipoDireccionLabel", header: "Tipo" },
                {
                  field: "vigente",
                  header: "Estado",
                  sortable: false,
                  body: (row) =>
                    row.vigente ? (
                      <Tag
                        value="Vigente"
                        severity="success"
                        className="text-xs px-2 py-1 border-round-2xl"
                      />
                    ) : (
                      <Tag
                        value="No vigente"
                        severity="danger"
                        className="text-xs px-2 py-1 border-round-2xl"
                      />
                    ),
                },
              ]}
              onRowClick={(row) => {
                const full = direcciones.find((d) => d.id === row.id) || null;
                setSelectedAddress(full);
                setAddressDetailOpen(true);
              }}
            />
          )}
        </TabPanel>
        <TabPanel header={<H icon="pi-envelope" text="CORREOS" />}>
          {view === "kanban" ? (
            <KanbanCards
              data={listEmails.map((e) => ({
                ...e,
                nombre: e.email,
                etiquetaTag: e.etiqueta ? (
                  <Tag
                    value={e.etiqueta}
                    severity="primary"
                    className="text-xs px-2 py-1 border-round-2xl mt-1 "
                  />
                ) : null,
                vigente: e.vigente,
              }))}
              icon="pi pi-envelope"
              onCardClick={handleEmailClick}
            />
          ) : (
            <SimpleList
              value={listEmails}
              cols={[
                { field: "email", header: "Correo" },
                { field: "etiqueta", header: "Etiqueta" },
                {
                  field: "vigente",
                  header: "Estado",
                  sortable: false,
                  body: (row) =>
                    row.vigente ? (
                      <Tag
                        value="Vigente"
                        severity="success"
                        className="text-xs px-2 py-1 border-round-2xl"
                      />
                    ) : (
                      <Tag
                        value="No vigente"
                        severity="danger"
                        className="text-xs px-2 py-1 border-round-2xl"
                      />
                    ),
                },
              ]}
            />
          )}
        </TabPanel>
        <TabPanel header={<H icon="pi-phone" text="TELÉFONOS" />}>
          {view === "kanban" ? (
            <KanbanCards
              data={listTels.map((t) => ({
                ...t,
                nombre: t.numero,
                email: t.etiqueta ? (
                  <Tag
                    value={t.etiqueta}
                    severity="primary"
                    className="text-xs px-2 py-1 border-round-2xl mt-1 "
                  />
                ) : null,
                vigente: t.vigente,
              }))}
              icon="pi pi-phone"
              onCardClick={(card) => handlePhoneClick(card)}
            />
          ) : (
            <SimpleList
              value={listTels}
              cols={[
                { field: "numero", header: "Número" },
                { field: "etiqueta", header: "Etiqueta" },
                {
                  field: "vigente",
                  header: "Estado",
                  sortable: false,
                  body: (row) =>
                    row.vigente ? (
                      <Tag
                        value="Vigente"
                        severity="success"
                        className="text-xs px-2 py-1 border-round-2xl"
                      />
                    ) : (
                      <Tag
                        value="No vigente"
                        severity="danger"
                        className="text-xs px-2 py-1 border-round-2xl"
                      />
                    ),
                },
              ]}
            />
          )}
        </TabPanel>
      </TabView>

      {/* Sidebar Filtros */}
      <Sidebar
        visible={filtersOpen}
        position="right"
        onHide={() => setFiltersOpen(false)}
        header="Filtros"
        className="w-full sm:w-25rem"
      >
        <div className="flex flex-col gap-3">
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Buscar por nombre, RUT o tipo de relación…"
              className="w-full"
            />
          </span>
          <div className="flex gap-2 mt-2">
            <Button
              label="Aplicar"
              icon="pi pi-check"
              onClick={() => setFiltersOpen(false)}
            />
            <Button
              label="Limpiar"
              icon="pi pi-filter-slash"
              severity="secondary"
              outlined
              onClick={() => setQuery("")}
            />
          </div>
        </div>
      </Sidebar>

      {/* Diálogo detalle de relación */}
      <Dialog
        header={
          detailContacto?.nombre ||
          detailContacto?.razonSocial ||
          "Detalle de relación"
        }
        visible={detailOpen}
        style={{ width: "50rem", maxWidth: "95vw" }}
        modal
        onHide={() => {
          setDetailOpen(false);
          setDetailContacto(null);
          setIsEditingRelation(false);
          setRelationError("");
        }}
        footer={
          <div className="flex justify-end gap-2">
            {!isEditingRelation ? (
              <>
                <Button
                  label="Cerrar"
                  outlined
                  onClick={() => {
                    setDetailOpen(false);
                    setDetailContacto(null);
                    setIsEditingRelation(false);
                    setRelationError("");
                  }}
                />
                <Button
                  label="Modificar"
                  icon="pi pi-pencil"
                  onClick={handleStartEditRelation}
                />
              </>
            ) : (
              <>
                <Button
                  label="Cancelar"
                  outlined
                  onClick={handleCancelEditRelation}
                  disabled={relationSaving}
                />
                <Button
                  label="Guardar cambios"
                  icon="pi pi-check"
                  onClick={handleSaveRelationContacts}
                  loading={relationSaving}
                  disabled={relationSaving}
                />
              </>
            )}
          </div>
        }
      >
        {detailContacto && (
          <div className="flex flex-column gap-4">
            {relationError && (
              <small className="p-error block">{relationError}</small>
            )}

            {/* CABECERA / RESUMEN */}
            <div className="flex flex-column gap-3">
              <div>
                <div className="text-sm text-color-secondary">
                  Tipo de relación
                </div>
                <div className="text-base font-medium">
                  {detailContacto.tipoRelacionLabel || "—"}
                </div>
              </div>

              <div>
                <div className="text-sm text-color-secondary">RUT</div>
                <div className="text-base">{detailContacto.rut || "—"}</div>
              </div>
            </div>

            <Divider />

            {/* CORREOS */}
            <div>
              <div className="flex justify-between items-center mb-2">
                <div className="text-sm text-color-secondary">Correos</div>
              </div>

              {relationWorking.correos?.length ? (
                <div className="flex flex-column gap-2">
                  {relationWorking.correos.map((c) => (
                    <div
                      key={c.id}
                      className="flex justify-between align-items-center p-2 border-1 border-200 border-round"
                    >
                      <div className="flex flex-column">
                        <span className="text-sm">{c.email}</span>
                        {c.etiqueta && (
                          <span className="text-xs text-color-secondary">
                            {c.etiqueta}
                          </span>
                        )}
                      </div>
                      {isEditingRelation && (
                        <Button
                          icon="pi pi-trash"
                          rounded
                          text
                          severity="danger"
                          onClick={() => handleRemoveCorreoFromRelation(c.id)}
                          tooltip="Quitar de la relación"
                        />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-sm text-color-secondary">
                  Sin correos asociados
                </div>
              )}

              {isEditingRelation && (
                <div className="flex gap-2 mt-2">
                  <Dropdown
                    value={selectedAddCorreoId}
                    onChange={(e) => setSelectedAddCorreoId(e.value)}
                    options={relationExistingData.correos
                      .filter(
                        (c) =>
                          !relationWorking.correos.some((rc) => rc.id === c.id)
                      )
                      .map((c) => ({
                        label: `${c.email}${
                          c.etiqueta ? ` — ${c.etiqueta}` : ""
                        }`,
                        value: c.id,
                      }))}
                    placeholder="Agregar correo de la persona…"
                    className="flex-1"
                    emptyMessage="No hay correos asociados a esta persona"
                  />
                  <Button
                    icon="pi pi-plus"
                    rounded
                    onClick={handleAddCorreoToRelation}
                    disabled={!selectedAddCorreoId}
                  />
                </div>
              )}
            </div>

            <Divider />

            {/* TELÉFONOS */}
            <div>
              <div className="flex justify-between items-center mb-2">
                <div className="text-sm text-color-secondary">Teléfonos</div>
              </div>

              {relationWorking.telefonos?.length ? (
                <div className="flex flex-column gap-2">
                  {relationWorking.telefonos.map((t) => (
                    <div
                      key={t.id}
                      className="flex justify-between align-items-center p-2 border-1 border-200 border-round"
                    >
                      <div className="flex flex-column">
                        <span className="text-sm">{t.numero}</span>
                        {t.etiqueta && (
                          <span className="text-xs text-color-secondary">
                            {t.etiqueta}
                          </span>
                        )}
                      </div>
                      {isEditingRelation && (
                        <Button
                          icon="pi pi-trash"
                          rounded
                          text
                          severity="danger"
                          onClick={() => handleRemoveTelefonoFromRelation(t.id)}
                          tooltip="Quitar de la relación"
                        />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-sm text-color-secondary">
                  Sin teléfonos asociados
                </div>
              )}

              {isEditingRelation && (
                <div className="flex gap-2 mt-2">
                  <Dropdown
                    value={selectedAddTelefonoId}
                    onChange={(e) => setSelectedAddTelefonoId(e.value)}
                    options={relationExistingData.telefonos
                      .filter(
                        (t) =>
                          !relationWorking.telefonos.some(
                            (rt) => rt.id === t.id
                          )
                      )
                      .map((t) => ({
                        label: `${t.numero}${
                          t.etiqueta ? ` — ${t.etiqueta}` : ""
                        }`,
                        value: t.id,
                      }))}
                    placeholder="Agregar teléfono de la persona…"
                    className="flex-1"
                    emptyMessage="No hay telefonos asociados a esta persona"
                  />
                  <Button
                    icon="pi pi-plus"
                    rounded
                    onClick={handleAddTelefonoToRelation}
                    disabled={!selectedAddTelefonoId}
                  />
                </div>
              )}
            </div>

            <Divider />

            {/* DIRECCIONES */}
            <div>
              <div className="flex justify-between items-center mb-2">
                <div className="text-sm text-color-secondary">Direcciones</div>
              </div>

              {relationWorking.direcciones?.length ? (
                <div className="flex flex-column gap-2">
                  {relationWorking.direcciones.map((d) => {
                    const linea1 = `${d.calle || ""} ${d.numero || ""}`.trim();
                    const linea2 = [d.comuna, d.ciudad, d.pais]
                      .filter(Boolean)
                      .join(", ");
                    return (
                      <div
                        key={d.id}
                        className="flex justify-between align-items-center p-2 border-1 border-200 border-round"
                      >
                        <div className="flex flex-column">
                          <span className="text-sm">{linea1 || "—"}</span>
                          <span className="text-xs text-color-secondary">
                            {linea2}
                          </span>
                        </div>
                        {isEditingRelation && (
                          <Button
                            icon="pi pi-trash"
                            rounded
                            text
                            severity="danger"
                            onClick={() =>
                              handleRemoveDireccionFromRelation(d.id)
                            }
                            tooltip="Quitar de la relación"
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-sm text-color-secondary">
                  Sin direcciones asociadas
                </div>
              )}

              {isEditingRelation && (
                <div className="flex gap-2 mt-2">
                  <Dropdown
                    value={selectedAddDireccionId}
                    onChange={(e) => setSelectedAddDireccionId(e.value)}
                    options={relationExistingData.direcciones
                      .filter(
                        (d) =>
                          !relationWorking.direcciones.some(
                            (rd) => rd.id === d.id
                          )
                      )
                      .map((d) => ({
                        label: `${d.calle || ""} ${d.numero || ""} — ${[
                          d.comuna,
                          d.ciudad,
                          d.pais,
                        ]
                          .filter(Boolean)
                          .join(", ")}`,
                        value: d.id,
                      }))}
                    placeholder="Agregar dirección de la persona…"
                    className="flex-1"
                    emptyMessage="No hay direcciones asociados a esta persona"
                  />
                  <Button
                    icon="pi pi-plus"
                    rounded
                    onClick={handleAddDireccionToRelation}
                    disabled={!selectedAddDireccionId}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </Dialog>

      {/* Diálogo detalle CORREO */}
      <Dialog
        header="Detalle de correo"
        visible={emailDetailOpen}
        style={{ width: "30rem", maxWidth: "95vw" }}
        modal
        onHide={() => {
          setEmailDetailOpen(false);
          setSelectedEmail(null);
        }}
      >
        {selectedEmail && (
          <div className="flex flex-column gap-3">
            <div>
              <div className="text-sm text-color-secondary">Correo</div>
              <div className="text-base font-medium">{selectedEmail.email}</div>
            </div>

            {selectedEmail.etiqueta && (
              <div>
                <div className="text-sm text-color-secondary">Etiqueta</div>
                <div className="text-base">{selectedEmail.etiqueta}</div>
              </div>
            )}

            <div>
              <div className="text-sm text-color-secondary">Estado</div>
              {selectedEmail.vigente ? (
                <Tag
                  value="Vigente"
                  severity="success"
                  className="text-xs px-2 py-1 border-round-2xl mt-1"
                />
              ) : (
                <Tag
                  value="No vigente"
                  severity="danger"
                  className="text-xs px-2 py-1 border-round-2xl mt-1"
                />
              )}
            </div>

            <div className="flex justify-end gap-2 mt-3">
              <Button
                label="Cerrar"
                outlined
                onClick={() => {
                  setEmailDetailOpen(false);
                  setSelectedEmail(null);
                }}
              />
              {selectedEmail.vigente ? (
                <Button
                  label="Quitar correo"
                  icon="pi pi-trash"
                  severity="danger"
                  onClick={desactivarCorreo}
                  loading={deleting}
                  disabled={deleting}
                />
              ) : (
                <Button
                  label="Activar correo"
                  icon="pi pi-check"
                  severity="success"
                  onClick={activarCorreo}
                  loading={deleting}
                  disabled={deleting}
                />
              )}
            </div>
          </div>
        )}
      </Dialog>

      {/* Diálogo detalle TELÉFONO */}
      <Dialog
        header="Detalle de teléfono"
        visible={phoneDetailOpen}
        style={{ width: "30rem", maxWidth: "95vw" }}
        modal
        onHide={() => {
          setPhoneDetailOpen(false);
          setSelectedPhone(null);
        }}
      >
        {selectedPhone && (
          <div className="flex flex-column gap-3">
            <div>
              <div className="text-sm text-color-secondary">Número</div>
              <div className="text-base font-medium">
                {selectedPhone.numero}
              </div>
            </div>

            <div>
              <div className="text-sm text-color-secondary">Etiqueta</div>
              <div className="text-base">{selectedPhone.etiqueta || "—"}</div>
            </div>

            <div>
              <div className="text-sm text-color-secondary">¿Principal?</div>
              <div className="text-base">
                {selectedPhone.principal ? "Sí" : "No"}
              </div>
            </div>

            <div>
              <div className="text-sm text-color-secondary">Estado</div>
              {selectedPhone.vigente ? (
                <Tag
                  value="Vigente"
                  severity="success"
                  className="text-xs px-2 py-1 border-round-2xl mt-1"
                />
              ) : (
                <Tag
                  value="No vigente"
                  severity="danger"
                  className="text-xs px-2 py-1 border-round-2xl mt-1"
                />
              )}
            </div>

            <div className="flex justify-end gap-2 mt-3">
              <Button
                label="Cerrar"
                outlined
                onClick={() => {
                  setPhoneDetailOpen(false);
                  setSelectedPhone(null);
                }}
              />
              {selectedPhone.vigente ? (
                <Button
                  label="Quitar teléfono"
                  icon="pi pi-trash"
                  severity="danger"
                  onClick={desactivarTelefono}
                  loading={deleting}
                  disabled={deleting}
                />
              ) : (
                <Button
                  label="Activar teléfono"
                  icon="pi pi-check"
                  severity="success"
                  onClick={activarTelefono}
                  loading={deleting}
                  disabled={deleting}
                />
              )}
            </div>
          </div>
        )}
      </Dialog>

      {/* Diálogo detalle DIRECCIÓN */}
      <Dialog
        header="Detalle de dirección"
        visible={addressDetailOpen}
        style={{ width: "35rem", maxWidth: "95vw" }}
        modal
        onHide={() => {
          setAddressDetailOpen(false);
          setSelectedAddress(null);
        }}
      >
        {selectedAddress && (
          <div className="flex flex-column gap-3">
            <div>
              <div className="text-sm text-color-secondary">Dirección</div>
              <div className="text-base font-medium">
                {[selectedAddress.calle, selectedAddress.numero]
                  .filter(Boolean)
                  .join(" ")}
              </div>
            </div>

            <div>
              <div className="text-sm text-color-secondary">
                Comuna / Ciudad / País
              </div>
              <div className="text-base">
                {[
                  selectedAddress.comuna,
                  selectedAddress.ciudad,
                  selectedAddress.pais,
                ]
                  .filter(Boolean)
                  .join(", ")}
              </div>
            </div>

            <div>
              <div className="text-sm text-color-secondary">Tipo</div>
              <div className="text-base">
                {selectedAddress.tipoDireccionLabel || "—"}
              </div>
            </div>

            <div>
              <div className="text-sm text-color-secondary">Estado</div>
              {selectedAddress.vigente ? (
                <Tag
                  value="Vigente"
                  severity="success"
                  className="text-xs px-2 py-1 border-round-2xl mt-1"
                />
              ) : (
                <Tag
                  value="No vigente"
                  severity="danger"
                  className="text-xs px-2 py-1 border-round-2xl mt-1"
                />
              )}
            </div>

            <div className="flex justify-between gap-2 mt-3 flex-wrap">
              <div className="flex gap-2">
                <Button
                  label="Ver detalles"
                  icon="pi pi-external-link"
                  outlined
                  onClick={() => {
                    if (selectedAddress?.id) {
                      navigate(`/direccion/${selectedAddress.id}`);
                    }
                  }}
                />
              </div>
              <div className="flex gap-2">
                <Button
                  label="Cerrar"
                  outlined
                  onClick={() => {
                    setAddressDetailOpen(false);
                    setSelectedAddress(null);
                  }}
                />
                {selectedAddress.vigente ? (
                  <Button
                    label="Quitar dirección"
                    icon="pi pi-trash"
                    severity="danger"
                    onClick={desactivarDireccion}
                    loading={deleting}
                    disabled={deleting}
                  />
                ) : (
                  <Button
                    label="Activar dirección"
                    icon="pi pi-check"
                    severity="success"
                    onClick={activarDireccion}
                    loading={deleting}
                    disabled={deleting}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </Dialog>

      {/* Diálogo Añadir dinámico */}
      <Dialog
        header={`Añadir ${addLabels[activeTab]}`}
        visible={addOpen}
        style={{ width: "70rem", maxWidth: "95vw" }}
        modal
        className="p-fluid"
        onHide={() => setAddOpen(false)}
        footer={
          <div className="flex justify-end gap-2">
            <Button
              label="Cancelar"
              outlined
              onClick={() => setAddOpen(false)}
              disabled={saving}
            />
            <Button
              label="Guardar"
              icon="pi pi-check"
              onClick={onSaveAdd}
              loading={saving}
              disabled={saving}
            />
          </div>
        }
      >
        {saveError && (
          <div className="mb-3">
            <small className="p-error">{saveError}</small>
          </div>
        )}
        {/* Contenido cambia según pestaña */}

        {(activeTab === 0 || activeTab === 1) && (
          <>
            {/* Input de búsqueda */}
            <label className="block text-sm font-medium mb-2">
              Buscar persona (nombre o RUT)
            </label>
            <AutoComplete
              value={
                typeof personSelected === "string"
                  ? personSelected
                  : personSelected?.label || personQuery
              }
              suggestions={personSugs}
              completeMethod={(e) => fetchPersonas(e.query)}
              field="label"
              dropdown
              placeholder="Escribe para buscar…"
              loading={personSearchLoading}
              className="w-full"
              onChange={(e) => {
                if (typeof e.value === "string") {
                  // si parece RUT, lo formateamos
                  let val = e.value;
                  const cleaned = val.replace(/[^\dkK]/g, "").toUpperCase();
                  const isRutLike =
                    /^[0-9]+[0-9kK]?$/.test(cleaned) || val.includes("-");

                  if (isRutLike) {
                    val = formatRut(cleaned);
                  }

                  setPersonSelected(val);
                  setPersonQuery(val);
                  setAddData((p) => ({
                    ...p,
                    personaRelacionadaId: undefined,
                  }));
                  setRutBusquedaError("");
                  setNoResults(false);
                  return;
                }

                // objeto seleccionado
                setPersonSelected(e.value);
                setPersonQuery(e.value?.label || "");
                setAddData((p) => ({
                  ...p,
                  personaRelacionadaId: e.value?.id,
                }));
                setNoResults(false);
                setRutBusquedaError("");

                loadExistingPersonaData(e.value.id);
              }}
              itemTemplate={(item) => (
                <div className="flex flex-column">
                  <div className="font-medium">{item.label}</div>
                  <div className="text-xs text-color-secondary">
                    {item.tipo}
                  </div>
                </div>
              )}
            />

            {rutBusquedaError && (
              <small className="p-error block mt-1">{rutBusquedaError}</small>
            )}

            <div className="field mt-3">
              <label className="block text-sm font-medium mb-2">
                Tipo de relación <span className="text-red-500">*</span>
              </label>
              <Dropdown
                value={tipoRelacionId}
                onChange={(e) => setTipoRelacionId(e.value)}
                options={tiposRel}
                optionLabel="label"
                optionValue="value"
                placeholder={tiposRelLoading ? "Cargando..." : "Seleccione"}
                disabled={tiposRelLoading}
                className={!tipoRelacionId && tiposRelError ? "p-invalid" : ""}
              />
              {tiposRelError && (
                <small className="p-error">{tiposRelError}</small>
              )}
            </div>

            {/* Si hay selección, mostrar ficha rápida */}
            {personSelected && typeof personSelected !== "string" && (
              <div className="mt-4 p-4 border-1 border-200 border-round">
                <div className="text-sm text-color-secondary mb-3">
                  Datos existentes de esta persona
                </div>

                {/* DIRECCIONES */}
                <div className="field col-12">
                  <label>Direcciones asociadas</label>
                  <Dropdown
                    value={selectedRelacion.direcciones}
                    onChange={(e) =>
                      setSelectedRelacion((p) => ({
                        ...p,
                        direcciones: e.value,
                      }))
                    }
                    options={existingData.direcciones.map((d) => ({
                      label: `${d.tipoDireccion?.descripcion || ""} — ${
                        d.calle
                      } ${d.numero}, ${d.comuna}`,
                      value: d.id,
                    }))}
                    placeholder="Seleccione"
                    className="w-full"
                    emptyMessage="No hay direcciones asociados a esta persona"
                    multiple
                  />
                </div>

                {/* CORREOS */}
                <div className="field col-12">
                  <label>Correos asociados</label>
                  <Dropdown
                    value={selectedRelacion.correos}
                    onChange={(e) =>
                      setSelectedRelacion((p) => ({
                        ...p,
                        correos: e.value,
                      }))
                    }
                    options={existingData.correos.map((c) => ({
                      label: `${c.email} — ${c.etiqueta || ""}`,
                      value: c.id,
                    }))}
                    placeholder="Seleccione"
                    className="w-full"
                    emptyMessage="No hay correos asociados a esta persona"
                    multiple
                  />
                </div>

                {/* TELÉFONOS */}
                <div className="field col-12">
                  <label>Teléfonos asociados</label>
                  <Dropdown
                    value={selectedRelacion.telefonos}
                    onChange={(e) =>
                      setSelectedRelacion((p) => ({
                        ...p,
                        telefonos: e.value,
                      }))
                    }
                    options={existingData.telefonos.map((t) => ({
                      label: `${t.numero} — ${t.etiqueta || ""}`,
                      value: t.id,
                    }))}
                    placeholder="Seleccione"
                    className="w-full"
                    emptyMessage="No hay teléfonos asociados a esta persona"
                    multiple
                  />
                </div>
              </div>
            )}

            {/* Si no hay resultados y se está escribiendo, mostrar formulario de creación */}
            {noResults && personQuery && (
              <div className="mt-4">
                <div className="mb-2 text-sm text-color-secondary">
                  No se encontraron resultados. Crear nueva{" "}
                  {tipoFromTab === "NATURAL"
                    ? "persona natural"
                    : "persona jurídica"}
                  :
                </div>

                {/* === FORMULARIO PERSONA === */}
                <div className="grid formgrid mb-4">
                  {/* País / Nacionalidad */}
                  <div className="field col-12 md:col-6">
                    <label className="block text-sm font-medium mb-2">
                      País / Nacionalidad{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <Dropdown
                      value={nuevo.nacionalidad}
                      onChange={(e) =>
                        setNuevo((p) => ({ ...p, nacionalidad: e.value }))
                      }
                      options={countryOptions}
                      optionLabel="label"
                      optionValue="code"
                      placeholder="Seleccione país"
                      itemTemplate={countryOptionTemplate}
                      valueTemplate={countryOptionTemplate}
                      className={
                        errors.nacionalidad ? "p-invalid w-full" : "w-full"
                      }
                    />
                    {errors.nacionalidad && (
                      <small className="p-error">{errors.nacionalidad}</small>
                    )}
                  </div>

                  {/* RUT */}
                  <div className="field col-12 md:col-6">
                    <label className="block text-sm font-medium mb-2">
                      RUT
                    </label>
                    <InputText
                      value={nuevo.rut || ""}
                      onChange={async (e) => {
                        const formatted = formatRut(e.target.value);
                        setNuevo((p) => ({ ...p, rut: formatted }));
                        setErrors((prev) => ({ ...prev, rut: undefined }));

                        // reset mientras escribe
                        setRutNuevoError("");
                        setRutNuevoExists(false);

                        const clean = cleanRut(formatted);
                        if (!clean) {
                          // campo vacío
                          setRutNuevoError("");
                          setRutNuevoExists(false);
                          return;
                        }

                        // validar módulo 11 primero
                        if (!isValidRut(formatted)) {
                          setRutNuevoError("RUT inválido");
                          setRutNuevoExists(false);
                          return;
                        }

                        // si es válido → consultar al backend si ya existe
                        try {
                          const url = `${baseUrl}personas/buscar?rut=${encodeURIComponent(
                            formatted
                          )}`;
                          const resp = await fetch(url, {
                            credentials: "include",
                          });
                          if (!resp.ok) {
                            // si el backend falla, no bloqueamos creación, solo limpiamos mensaje
                            setRutNuevoError("");
                            setRutNuevoExists(false);
                            return;
                          }

                          const data = await resp.json();
                          const exists = (data.items || []).length > 0;

                          if (exists) {
                            setRutNuevoError(
                              "Este RUT ya se encuentra registrado."
                            );
                            setRutNuevoExists(true);
                          } else {
                            setRutNuevoError("");
                            setRutNuevoExists(false);
                          }
                        } catch (err) {
                          console.error("Error verificando RUT nuevo:", err);
                          setRutNuevoError("");
                          setRutNuevoExists(false);
                        }
                      }}
                      className={errors.rut || rutNuevoError ? "p-invalid" : ""}
                      placeholder="12.345.678-9"
                    />
                    {(errors.rut || rutNuevoError) && (
                      <small className="p-error">
                        {rutNuevoError || errors.rut}
                      </small>
                    )}

                    {rutStatusNuevo === "valid" && !errors.rut && (
                      <small
                        className="block mt-1"
                        style={{ color: "var(--green-600)" }}
                      >
                        RUT válido
                      </small>
                    )}

                    {errors.rut && (
                      <small className="p-error">{errors.rut}</small>
                    )}
                  </div>

                  {tipoFromTab === "NATURAL" ? (
                    <>
                      <div className="field col-12 md:col-6">
                        <label className="block text-sm font-medium mb-2">
                          Primer nombre <span className="text-red-500">*</span>
                        </label>
                        <InputText
                          value={form.primerNombre}
                          onChange={(e) =>
                            setField("primerNombre", e.target.value)
                          }
                          className={errors.primerNombre ? "p-invalid" : ""}
                        />
                        {errors.primerNombre && (
                          <small className="p-error">
                            {errors.primerNombre}
                          </small>
                        )}
                      </div>

                      <div className="field col-12 md:col-6">
                        <label className="block text-sm font-medium mb-2">
                          Segundo nombre
                        </label>
                        <InputText
                          value={form.segundoNombre}
                          onChange={(e) =>
                            setField("segundoNombre", e.target.value)
                          }
                        />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label className="block text-sm font-medium mb-2">
                          Apellido paterno{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <InputText
                          value={form.apellidoPaterno}
                          onChange={(e) =>
                            setField("apellidoPaterno", e.target.value)
                          }
                          className={errors.apellidoPaterno ? "p-invalid" : ""}
                        />
                        {errors.apellidoPaterno && (
                          <small className="p-error">
                            {errors.apellidoPaterno}
                          </small>
                        )}
                      </div>

                      <div className="field col-12 md:col-6">
                        <label className="block text-sm font-medium mb-2">
                          Apellido materno{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <InputText
                          value={form.apellidoMaterno}
                          onChange={(e) =>
                            setField("apellidoMaterno", e.target.value)
                          }
                          className={errors.apellidoMaterno ? "p-invalid" : ""}
                        />
                        {errors.apellidoMaterno && (
                          <small className="p-error">
                            {errors.apellidoMaterno}
                          </small>
                        )}
                      </div>

                      <div className="field col-12 md:col-6">
                        <label className="block text-sm font-medium mb-2">
                          Fecha de nacimiento{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <Calendar
                          value={form.fechaNacimiento}
                          onChange={(e) => setField("fechaNacimiento", e.value)}
                          showIcon
                          showButtonBar
                          dateFormat="dd/mm/yy"
                          placeholder="dd/mm/aaaa"
                          maxDate={today}
                          className={errors.fechaNacimiento ? "p-invalid" : ""}
                        />
                        {errors.fechaNacimiento && (
                          <small className="p-error">
                            {errors.fechaNacimiento}
                          </small>
                        )}
                      </div>

                      <div className="field col-12 md:col-6">
                        <label className="block text-sm font-medium mb-2">
                          Género <span className="text-red-500">*</span>
                        </label>
                        <Dropdown
                          value={form.genero}
                          onChange={(e) => setField("genero", e.value)}
                          options={generoOptions}
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Seleccione"
                          className={errors.genero ? "p-invalid" : ""}
                        />
                        {errors.genero && (
                          <small className="p-error">{errors.genero}</small>
                        )}
                      </div>
                    </>
                  ) : (
                    // JURÍDICA
                    <div className="field col-12">
                      <label className="block text-sm font-medium mb-2">
                        Razón social <span className="text-red-500">*</span>
                      </label>
                      <InputText
                        value={nuevo.razonSocial}
                        onChange={(e) =>
                          setNuevo((p) => ({
                            ...p,
                            razonSocial: e.target.value,
                          }))
                        }
                      />
                    </div>
                  )}
                </div>

                {/* === CHIPS para agregar datos extras === */}
                <div className="mb-2 text-sm text-color-secondary">
                  Opcional: agregar datos de contacto iniciales
                </div>

                <div className="flex flex-wrap gap-2 mb-3">
                  <Tag
                    value="Dirección"
                    className={`cursor-pointer px-3 py-1 text-xs border-round-2xl ${
                      showDirExtra
                        ? "bg-primary text-white"
                        : "surface-100 text-color-secondary"
                    }`}
                    icon="pi pi-map-marker"
                    onClick={() => setShowDirExtra((v) => !v)}
                  />
                  <Tag
                    value="Correo"
                    className={`cursor-pointer px-3 py-1 text-xs border-round-2xl ${
                      showCorreoExtra
                        ? "bg-primary text-white"
                        : "surface-100 text-color-secondary"
                    }`}
                    icon="pi pi-envelope"
                    onClick={() => setShowCorreoExtra((v) => !v)}
                  />
                  <Tag
                    value="Teléfono"
                    className={`cursor-pointer px-3 py-1 text-xs border-round-2xl ${
                      showTelefonoExtra
                        ? "bg-primary text-white"
                        : "surface-100 text-color-secondary"
                    }`}
                    icon="pi pi-phone"
                    onClick={() => setShowTelefonoExtra((v) => !v)}
                  />
                </div>

                {/* === FORM EXTRA: DIRECCIÓN === */}
                {showDirExtra && (
                  <div className="flex flex-column gap-3 mb-3">
                    <div className="field">
                      <label className="block text-sm font-medium mb-2">
                        Dirección (autocomplete)
                      </label>

                      <AutoComplete
                        value={addData.direccionQuery || ""}
                        suggestions={dirSugs}
                        completeMethod={(e) => fetchDirecciones(e.query)}
                        field="direccion"
                        dropdown
                        loading={dirLoading}
                        placeholder="Ej: Agustinas 123 Santiago"
                        className="w-full"
                        onChange={(e) => {
                          setAddData((p) => ({
                            ...p,
                            direccionQuery: e.value,
                            direccionSeleccionada: null,
                          }));
                        }}
                        onSelect={(e) => {
                          setAddData((p) => ({
                            ...p,
                            direccionQuery: e.value.direccion,
                            direccionSeleccionada: e.value,
                          }));
                        }}
                        itemTemplate={(item) => (
                          <div className="flex flex-column">
                            <div className="font-medium">{item.direccion}</div>
                            <div className="text-xs text-color-secondary">
                              {item.comuna}, {item.ciudad}, {item.pais}
                            </div>
                          </div>
                        )}
                      />
                    </div>

                    {/* NUEVO: tipo de dirección para la dirección extra */}
                    <div className="field">
                      <label className="block text-sm font-medium mb-2">
                        Tipo de dirección
                      </label>
                      <Dropdown
                        value={addData.tipoDireccionId || null}
                        onChange={(e) =>
                          setAddData((p) => ({
                            ...p,
                            tipoDireccionId: e.value,
                          }))
                        }
                        options={tiposDireccion}
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Seleccione tipo"
                        className="w-full"
                      />
                    </div>

                    {addData.direccionSeleccionada && (
                      <div className="p-3 border-1 border-200 border-round surface-50">
                        <div className="font-medium text-sm mb-1">
                          Dirección seleccionada:
                        </div>
                        <div>{addData.direccionSeleccionada.direccion}</div>
                        <div className="text-xs text-color-secondary">
                          {addData.direccionSeleccionada.comuna},{" "}
                          {addData.direccionSeleccionada.ciudad},{" "}
                          {addData.direccionSeleccionada.pais}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* === FORM EXTRA: CORREO === */}
                {showCorreoExtra && (
                  <div className="grid formgrid mb-3">
                    <div className="field col-12 md:col-6">
                      <label className="block text-sm font-medium mb-2">
                        Correo
                      </label>
                      <InputText
                        value={addData.email || ""}
                        onChange={(e) =>
                          setAddData((p) => ({ ...p, email: e.target.value }))
                        }
                      />
                    </div>
                    <div className="field col-12 md:col-6">
                      <label className="block text-sm font-medium mb-2">
                        Etiqueta
                      </label>
                      <InputText
                        value={addData.etiqueta || ""}
                        onChange={(e) =>
                          setAddData((p) => ({
                            ...p,
                            etiqueta: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                )}

                {/* === FORM EXTRA: TELÉFONO === */}
                {showTelefonoExtra && (
                  <div className="mb-3">
                    <div className="grid formgrid">
                      {/* Código de país */}
                      <div className="field col-12 md:col-4">
                        <label className="block text-sm font-medium mb-2">
                          Código de país
                        </label>
                        <Dropdown
                          value={phoneCountryCode}
                          onChange={(e) => setPhoneCountryCode(e.value)}
                          options={phoneCodeOptions}
                          optionLabel="label"
                          optionValue="code"
                          placeholder="Seleccione"
                          itemTemplate={phoneCodeOptionTemplate}
                          valueTemplate={phoneCodeOptionTemplate}
                          className="w-full"
                        />
                      </div>

                      {/* Número local */}
                      <div className="field col-12 md:col-4">
                        <label className="block text-sm font-medium mb-2">
                          Número (sin código)
                        </label>
                        <InputText
                          value={addData.numero || ""}
                          onChange={(e) =>
                            setAddData((p) => ({
                              ...p,
                              numero: e.target.value,
                            }))
                          }
                          placeholder="9 1234 5678"
                        />
                      </div>

                      {/* Etiqueta */}
                      <div className="field col-12 md:col-4">
                        <label className="block text-sm font-medium mb-2">
                          Etiqueta
                        </label>
                        <InputText
                          value={addData.etiqueta || ""}
                          onChange={(e) =>
                            setAddData((p) => ({
                              ...p,
                              etiqueta: e.target.value,
                            }))
                          }
                          placeholder="Móvil, Fijo…"
                        />
                      </div>
                    </div>

                    <small className="text-xs text-color-secondary block mt-1">
                      Se guardará como{" "}
                      {phoneCountryCode && addData.numero
                        ? `${phoneCountryCode} ${addData.numero}`
                        : "—"}
                    </small>
                  </div>
                )}
              </div>
            )}
          </>
        )}

        {activeTab === 2 && (
          <div className="flex flex-column gap-3">
            {/* Campo: Dirección (autocomplete) */}
            <div className="field">
              <label className="block text-sm font-medium mb-2">
                Dirección (calle y número, comuna, ciudad…)
              </label>

              <AutoComplete
                value={dirQuery}
                suggestions={dirSugs}
                completeMethod={(e) => fetchDirecciones(e.query)}
                field="direccion"
                dropdown
                placeholder="Ej: Agustinas 123 Santiago"
                loading={dirLoading}
                className="w-full"
                onChange={(e) => {
                  setDirQuery(e.value);
                  setDirSelected(null);
                }}
                onSelect={(e) => {
                  setDirSelected(e.value);
                  setDirQuery(e.value.direccion);
                }}
                itemTemplate={(item) => (
                  <div className="flex flex-column">
                    <div className="font-medium">{item.direccion}</div>
                    <div className="text-xs text-color-secondary">
                      {item.comuna}, {item.ciudad}, {item.pais}
                    </div>
                  </div>
                )}
              />
            </div>

            <div className="field mt-3">
              <label className="block text-sm font-medium mb-2">
                Tipo de dirección
              </label>
              <Dropdown
                value={tipoSeleccionado}
                onChange={(e) => setTipoSeleccionado(e.value)}
                options={tiposDireccion}
                optionLabel="label"
                optionValue="value"
                placeholder="Seleccione tipo"
                className="w-full"
              />
            </div>

            {dirSelected && (
              <div className="p-3 border-1 border-200 border-round surface-50">
                <div className="font-medium text-sm mb-1">
                  Dirección seleccionada:
                </div>
                <div>{dirSelected.direccion}</div>
                <div className="text-xs text-color-secondary">
                  {dirSelected.comuna}, {dirSelected.ciudad}, {dirSelected.pais}
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 3 && (
          <>
            <label className="block text-sm font-medium mb-2">Correo</label>
            <InputText
              value={addData.email || ""}
              onChange={(e) =>
                setAddData((p) => ({ ...p, email: e.target.value }))
              }
            />
            <label className="block text-sm font-medium mb-2 mt-3">
              Etiqueta
            </label>
            <InputText
              value={addData.etiqueta || ""}
              onChange={(e) =>
                setAddData((p) => ({ ...p, etiqueta: e.target.value }))
              }
            />
          </>
        )}

        {activeTab === 4 && (
          <div className="mb-2">
            <div className="grid formgrid">
              {/* Código de país */}
              <div className="field col-12 md:col-4">
                <label className="block text-sm font-medium mb-2">
                  Código de país
                </label>
                <Dropdown
                  value={phoneCountryCode}
                  onChange={(e) => setPhoneCountryCode(e.value)}
                  options={phoneCodeOptions}
                  optionLabel="label"
                  optionValue="code"
                  placeholder="Seleccione"
                  itemTemplate={phoneCodeOptionTemplate}
                  valueTemplate={phoneCodeOptionTemplate}
                  className="w-full"
                />
              </div>

              {/* Número local */}
              <div className="field col-12 md:col-4">
                <label className="block text-sm font-medium mb-2">Número</label>
                <InputText
                  value={addData.numero || ""}
                  onChange={(e) =>
                    setAddData((p) => ({ ...p, numero: e.target.value }))
                  }
                  placeholder="9 1234 5678"
                />
              </div>

              {/* Etiqueta */}
              <div className="field col-12 md:col-4">
                <label className="block text-sm font-medium mb-2">
                  Etiqueta
                </label>
                <InputText
                  value={addData.etiqueta || ""}
                  onChange={(e) =>
                    setAddData((p) => ({ ...p, etiqueta: e.target.value }))
                  }
                  placeholder="Móvil, Fijo…"
                />
              </div>
            </div>

            <small className="text-xs text-color-secondary block mt-1">
              Se guardará como{" "}
              {phoneCountryCode && addData.numero
                ? `${phoneCountryCode} ${addData.numero}`
                : "—"}
            </small>
          </div>
        )}
      </Dialog>

      {/* Diálogo editar datos de la persona */}
      <Dialog
        header="Editar datos de la persona"
        visible={editOpen}
        style={{ width: "40rem", maxWidth: "95vw" }}
        modal
        className="p-fluid"
        onHide={() => setEditOpen(false)}
        footer={
          <div className="flex justify-end gap-2">
            <Button
              label="Cancelar"
              outlined
              onClick={() => setEditOpen(false)}
              disabled={editSaving}
            />
            <Button
              label="Guardar cambios"
              icon="pi pi-check"
              onClick={handleSaveEditPersona}
              loading={editSaving}
              disabled={editSaving}
            />
          </div>
        }
      >
        {editError && (
          <div className="mb-3">
            <small className="p-error">{editError}</small>
          </div>
        )}

        {persona && (
          <>
            {/* Tipo de persona */}
            {(persona.tipo || "").toUpperCase() === "LEAD" ? (
              <div className="field">
                <label className="block text-sm font-medium mb-2">
                  Tipo de persona
                </label>
                <SelectButton
                  value={editTipo}
                  onChange={(e) => setEditTipo(e.value)}
                  options={[
                    { label: "Lead", value: "LEAD" },
                    { label: "Natural", value: "NATURAL" },
                    { label: "Jurídica", value: "JURIDICA" },
                  ]}
                  optionLabel="label"
                  optionValue="value"
                />
              </div>
            ) : (
              <div className="field">
                <label className="block text-sm font-medium mb-2">
                  Tipo de persona
                </label>
                <div className="flex items-center gap-2">
                  <Tag
                    value={
                      (persona.tipo || "").toUpperCase() === "NATURAL"
                        ? "Persona Natural"
                        : "Persona Jurídica"
                    }
                    severity="info"
                    className="text-xs px-3 py-1 border-round-2xl"
                  />
                </div>
              </div>
            )}

            <Divider />

            <div className="field">
              <label className="block text-sm font-medium mb-2">
                Foto de perfil
              </label>

              <div className="flex items-center gap-3">
                <div className="surface-200 w-5rem h-5rem border-circle overflow-hidden flex items-center justify-center">
                  {fotoDataUrl ? (
                    <img
                      src={fotoDataUrl}
                      alt="Foto de perfil"
                      className="w-full h-full"
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    <i className="pi pi-user text-2xl text-color-secondary" />
                  )}
                </div>

                <div className="flex-1">
                  <input
                    type="file"
                    accept="image/png,image/jpeg,image/jpg,image/webp"
                    onChange={(e) => {
                      setFotoError("");
                      const f = e.target.files?.[0] || null;
                      setFotoFile(f);
                    }}
                  />

                  <div className="flex gap-2 mt-2">
                    <Button
                      label="Subir foto"
                      icon="pi pi-upload"
                      onClick={uploadFotoPerfil}
                      loading={fotoUploading}
                      disabled={!fotoFile || fotoUploading}
                    />
                    <Button
                      label="Quitar selección"
                      icon="pi pi-times"
                      outlined
                      onClick={() => {
                        setFotoFile(null);
                        setFotoError("");
                      }}
                      disabled={fotoUploading}
                    />
                  </div>

                  {fotoError && (
                    <small className="p-error block mt-2">{fotoError}</small>
                  )}
                  {fotoFile && !fotoError && (
                    <small className="text-xs text-color-secondary block mt-2">
                      Seleccionado: {fotoFile.name}
                    </small>
                  )}
                </div>
              </div>

              <small className="text-xs text-color-secondary block mt-2">
                Máx 2MB. Formatos: JPG/JPEG/PNG/WebP.
              </small>
            </div>

            <Divider />

            {/* Campos comunes */}
            <div className="grid formgrid">
              <div className="field col-12 md:col-6">
                <label className="block text-sm font-medium mb-2">RUT</label>
                <InputText
                  value={editForm.rut || ""}
                  onChange={(e) =>
                    setEditField("rut", formatRut(e.target.value))
                  }
                  className={editErrors.rut ? "p-invalid" : ""}
                  placeholder="12.345.678-9"
                />
                {editErrors.rut && (
                  <small className="p-error">{editErrors.rut}</small>
                )}
              </div>

              <div className="field col-12 md:col-6">
                <label className="block text-sm font-medium mb-2">
                  País / Nacionalidad
                </label>
                <Dropdown
                  value={editForm.nacionalidad || ""}
                  onChange={(e) => setEditField("nacionalidad", e.value)}
                  options={countryOptions}
                  optionLabel="label"
                  optionValue="code"
                  placeholder="Seleccione país"
                  itemTemplate={countryOptionTemplate}
                  valueTemplate={countryOptionTemplate}
                />
              </div>
            </div>

            {/* Form dinámico según tipo */}
            {editTipo === "LEAD" && (
              <div className="field">
                <label className="block text-sm font-medium mb-2">
                  Descripción del lead
                </label>
                <InputTextarea
                  rows={4}
                  value={editForm.descripcionLead || ""}
                  onChange={(e) =>
                    setEditField("descripcionLead", e.target.value)
                  }
                  autoResize
                />
              </div>
            )}

            {editTipo === "NATURAL" && (
              <div className="grid formgrid mt-3">
                <div className="field col-12 md:col-6">
                  <label className="block text-sm font-medium mb-2">
                    Primer nombre
                  </label>
                  <InputText
                    value={editForm.primerNombre}
                    onChange={(e) =>
                      setEditField("primerNombre", e.target.value)
                    }
                    className={editErrors.primerNombre ? "p-invalid" : ""}
                  />
                  {editErrors.primerNombre && (
                    <small className="p-error">{editErrors.primerNombre}</small>
                  )}
                </div>

                <div className="field col-12 md:col-6">
                  <label className="block text-sm font-medium mb-2">
                    Segundo nombre
                  </label>
                  <InputText
                    value={editForm.segundoNombre}
                    onChange={(e) =>
                      setEditField("segundoNombre", e.target.value)
                    }
                  />
                </div>

                <div className="field col-12 md:col-6">
                  <label className="block text-sm font-medium mb-2">
                    Apellido paterno
                  </label>
                  <InputText
                    value={editForm.apellidoPaterno}
                    onChange={(e) =>
                      setEditField("apellidoPaterno", e.target.value)
                    }
                    className={editErrors.apellidoPaterno ? "p-invalid" : ""}
                  />
                  {editErrors.apellidoPaterno && (
                    <small className="p-error">
                      {editErrors.apellidoPaterno}
                    </small>
                  )}
                </div>

                <div className="field col-12 md:col-6">
                  <label className="block text-sm font-medium mb-2">
                    Apellido materno
                  </label>
                  <InputText
                    value={editForm.apellidoMaterno}
                    onChange={(e) =>
                      setEditField("apellidoMaterno", e.target.value)
                    }
                    className={editErrors.apellidoMaterno ? "p-invalid" : ""}
                  />
                  {editErrors.apellidoMaterno && (
                    <small className="p-error">
                      {editErrors.apellidoMaterno}
                    </small>
                  )}
                </div>

                <div className="field col-12 md:col-6">
                  <label className="block text-sm font-medium mb-2">
                    Fecha de nacimiento
                  </label>
                  <Calendar
                    value={editForm.fechaNacimiento}
                    onChange={(e) => setEditField("fechaNacimiento", e.value)}
                    showIcon
                    showButtonBar
                    dateFormat="dd/mm/yy"
                    placeholder="dd/mm/aaaa"
                    maxDate={today}
                  />
                </div>

                <div className="field col-12 md:col-6">
                  <label className="block text-sm font-medium mb-2">
                    Género
                  </label>
                  <Dropdown
                    value={editForm.genero}
                    onChange={(e) => setEditField("genero", e.value)}
                    options={generoOptions}
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Seleccione"
                  />
                </div>
              </div>
            )}

            {editTipo === "JURIDICA" && (
              <div className="field mt-3">
                <label className="block text-sm font-medium mb-2">
                  Razón social
                </label>
                <InputText
                  value={editForm.razonSocial}
                  onChange={(e) => setEditField("razonSocial", e.target.value)}
                  className={editErrors.razonSocial ? "p-invalid" : ""}
                />
                {editErrors.razonSocial && (
                  <small className="p-error">{editErrors.razonSocial}</small>
                )}
              </div>
            )}
          </>
        )}
      </Dialog>
    </div>
  );
};

export default Contacto;
